/**
 * Русская локализация
 */
export default {
  pipeline: {
    constructor: {
      title: 'Конструктор канбана',
      subtitle: 'Настройте этапы воронки и обязательные задачи на каждом этапе',
      reset: 'Сбросить',
      save: 'Сохранить воронку',
      saved: 'Воронка сохранена',
      color: 'Цвет',
      newStage: 'Новый этап',
      stageName: 'Название этапа',
      stageNamePlaceholder: 'Например, Презентация назначена',
      stageType: 'Тип этапа',
      terminalHint:
        '«Успех» и «Провал» — финальные этапы, закрывают сделку (выиграна / проиграна с причиной).',
      createStage: 'Создать этап',
      typeNormal: 'Обычный',
      typeWon: 'Успех',
      typeLost: 'Провал',
      tasksCount: '{n} задач',
      wipLimit: 'Лимит карточек (WIP)',
      mandatory: 'Обязательная',
      optional: 'Опциональная',
      overdueIn: 'Просрочка через {d}',
      nDays: '{n} дн',
      nHours: '{n} ч',
      addTask: 'Добавить задачу',
      addStage: 'Добавить этап',
      deleteStage: {
        title: 'Удалить этап «{name}»?',
        protectedTitle: 'Этап «{name}» нельзя удалить',
        protectedText: 'Это системный этап воронки — он защищён от удаления и переноса.',
        protectedNote:
          'Стартовый этап «Не разобрано» и финальные «Успех» / «Провал» защищены, чтобы воронка оставалась корректной.',
        emptyText:
          'В этапе нет активных сделок — переносить нечего. Этап и его шаблоны задач будут удалены.',
        reassignText:
          'В этапе «{name}» активных сделок: {count}. Выберите этап для переноса — этап и его шаблоны задач будут удалены безвозвратно.',
        moveLabel: 'Перенести {count} сделок в этап',
        selectPlaceholder: 'Выберите этап',
        selectFirst: 'Сначала выберите этап',
        dealsShort: '{n} сделка | {n} сделки | {n} сделок',
        summary: '{count} сделок перейдут в этап «{target}»',
        templatesNote: 'Шаблоны задач этапа ({n}) удалятся.',
        reassignTemplatesNote:
          'Шаблоны задач этапа ({n}) удалятся. Уже созданные задачи в сделках сохранятся в их истории.',
        confirm: 'Удалить этап',
        understood: 'Понятно',
        movedToast: '{count} сделок перенесено в этап «{target}»',
        deletedToast: 'Этап удалён',
      },
      loadError: 'Не удалось загрузить воронку',
      saveError: 'Не удалось сохранить изменения',
    },
    taskEditor: {
      title: 'Задача этапа',
      taskName: 'Название задачи',
      taskNamePlaceholder: 'Например, Согласовать бюджет и сроки',
      mandatory: 'Обязательная задача',
      mandatoryHint: 'Блокирует перевод сделки на следующий этап, пока не выполнена',
      deadline: 'Срок выполнения',
      noDeadline: 'Без срока',
      afterDeadline: 'Через срок',
      hours: 'часов',
      days: 'дней',
      afterEnter: 'после входа в этап',
      priority: 'Приоритет',
      low: 'Низкий',
      medium: 'Средний',
      high: 'Высокий',
      save: 'Сохранить задачу',
    },
    blocked: {
      modalTitle: 'Переход заблокирован',
      heading: 'Сначала выполните обязательные задачи',
      body: 'Чтобы перевести сделку на этап «{stage}», нужно закрыть обязательные задачи текущего этапа с комментарием о результате:',
      tasksLine: 'Не все обязательные задачи выполнены с комментарием',
      openTask: 'К задачам',
      openDeal: 'В карточку сделки',
    },
  },
  common: {
    // DEV-1253. Отказ в доступе называется отказом: до реформы он выглядел как
    // пустой справочник, и человек решал, что данных нет.
    access: {
      forbiddenTitle: 'Раздел недоступен',
      forbiddenDescription:
        'У вашей роли нет доступа к этому разделу. Если он нужен для работы — напишите администратору.',
      toDashboard: 'На главную',
      noAccessTitle: 'Доступ в CRM закрыт',
      noAccessDescription:
        'Ваша учётная запись не относится к этому приложению. Войдите под рабочей учётной записью или обратитесь к администратору.',
      logout: 'Выйти',
    },
    desktopOnly: {
      title: 'Этот экран рассчитан на компьютер',
      description:
        'Экран рассчитан на широкий монитор: с телефона видна малая его часть, и работать с ним нельзя. Откройте раздел с компьютера или с планшета в альбомной ориентации.',
      back: 'Назад',
    },
    hints: {
      languageSettings: 'Сменить язык можно здесь!',
    },
    unknownManager: 'Неизвестный менеджер',
    table: {
      selected: 'Выбрано: {count}',
      noData: 'Нет данных для отображения',
      noDataHint: 'Попробуйте изменить фильтры или добавить новые записи',
      actions: 'Действия',
    },
    actions: {
      create: 'Создать',
      new: 'Новый',
      globalSearch: 'Поиск клиентов, сделок, объектов…',
      collapseSidebar: 'Свернуть меню',
      openMenu: 'Открыть меню',
      loadMore: 'Загрузить ещё',
      edit: 'Редактировать',
      delete: 'Удалить',
      save: 'Сохранить',
      cancel: 'Отмена',
      confirm: 'Подтвердить',
      back: 'Назад',
      next: 'Далее',
      finish: 'Завершить',
      search: 'Поиск',
      filter: 'Фильтр',
      reset: 'Сбросить',
      close: 'Закрыть',
      add: 'Добавить',
      remove: 'Удалить',
      view: 'Просмотр',
      download: 'Скачать',
      upload: 'Загрузить',
      export: 'Экспорт',
      import: 'Импорт',
      print: 'Печать',
      share: 'Поделиться',
      retry: 'Попробовать снова',
      clear: 'Очистить',
      apply: 'Применить',
      all: 'Все',
      yes: 'Да',
      no: 'Нет',
    },
    globalSearch: {
      groups: {
        clients: 'Клиенты',
        deals: 'Сделки',
        properties: 'Объекты',
      },
      hint: 'Начните вводить запрос — поиск по клиентам, сделкам и объектам',
      minChars: 'Введите минимум 2 символа',
      loading: 'Идёт поиск…',
      empty: 'Ничего не найдено',
      emptyHint: 'Попробуйте изменить запрос',
      error: 'Не удалось выполнить поиск',
      navHint: 'навигация',
      openHint: 'открыть',
      recent: 'Недавнее',
      newClient: 'Новый клиент',
      newDeal: 'Новая сделка',
    },
    calendar: {
      today: 'Сегодня',
      weekDays: {
        mon: 'Пн',
        tue: 'Вт',
        wed: 'Ср',
        thu: 'Чт',
        fri: 'Пт',
        sat: 'Сб',
        sun: 'Вс',
      },
      presets: {
        today: 'Сегодня',
        last7Days: 'Последние 7 дней',
        thisMonth: 'Этот месяц',
      },
    },
    views: {
      table: 'Таблица',
      kanban: 'Канбан',
    },
    labels: {
      name: 'Название',
      description: 'Описание',
      date: 'Дата',
      status: 'Статус',
      type: 'Тип',
      price: 'Цена',
      address: 'Адрес',
      city: 'Город',
      country: 'Страна',
      phone: 'Телефон',
      email: 'Email',
      notes: 'Заметки',
      comments: 'Комментарии',
      createdAt: 'Дата создания',
      updatedAt: 'Дата обновления',
      theme: 'Тема',
      lightTheme: 'Светлая тема',
      darkTheme: 'Тёмная тема',
      notifications: 'Уведомления',
      noResults: 'Ничего не найдено',
      search: 'Поиск',
      yes: 'Да',
      no: 'Нет',
      other: 'Другое',
    },
    messages: {
      loading: 'Загрузка...',
      noData: 'Нет данных',
      error: 'Произошла ошибка',
      success: 'Успешно',
      confirmDelete: 'Вы уверены, что хотите удалить?',
      requiredField: 'Это поле обязательно',
      invalidEmail: 'Некорректный email',
      invalidPhone: 'Некорректный номер телефона',
    },
    errors: {
      loadingFailed: 'Ошибка загрузки',
      saveFailed: 'Ошибка сохранения',
      deleteFailed: 'Ошибка удаления',
      networkError: 'Ошибка сети',
      unauthorized: 'Требуется авторизация',
      forbidden: 'Доступ запрещён',
      notFound: 'Не найдено',
      serverError: 'Ошибка сервера',
    },
    navigation: {
      partnerCompanies: 'Компании-партнёры',
      notifications: 'Уведомления',
      home: 'Главная',
      dashboard: 'Дашборд',
      profile: 'Кабинет',
      clients: 'Клиенты',
      agents: 'Агенты',
      agentsRegistry: 'Реестр агентов',
      moderation: 'Модерация',
      analytics: 'Аналитика',
      properties: 'Объекты',
      projectsSection: 'Управление проектами',
      projectsList: 'Проекты',
      projectsImport: 'Импорт проектов',
      deals: 'Сделки',
      calendar: 'Календарь',
      reports: 'Отчёты',
      settings: 'Настройки',
      tools: 'Инструменты',
      calls: 'Звонки',
      documents: 'Документы',
      system: 'Система',
      managerAnalytics: 'Аналитика менеджеров',
      routingRules: 'Маршрутизация',
      pipelineConstructor: 'Конструктор воронки',
      personalSettings: 'Персональные настройки',
      administration: 'Администрирование',
    },
    pagination: {
      showing: 'Показано {count} из {total}',
      page: 'Страница {current} из {total}',
      previous: 'Предыдущая',
      next: 'Следующая',
    },
  },
  history: {
    loading: 'Загрузка истории…',
    loadMore: 'Показать ещё',
    taskBadge: 'Задача',
    openTasks: 'К задачам',
    taskResult: 'Результат: {result}',
    filters: {
      action: 'Тип действия',
      allActions: 'Все действия',
      actor: 'Автор',
      allActors: 'Все авторы',
      period: 'Период',
    },
    empty: {
      title: 'История пуста',
      description: 'Изменений пока нет',
    },
    actions: {
      created: 'Создание',
      updated: 'Изменение',
      deleted: 'Удаление',
      manager_changed: 'Смена менеджера',
      note_added: 'Заметка',
      contact_added: 'Контакт добавлен',
      contact_removed: 'Контакт удалён',
      task_created: 'Задача создана',
      task_updated: 'Задача изменена',
      task_completed: 'Задача выполнена',
      task_auto_closed: 'Задача закрыта автоматически',
      task_deleted: 'Задача удалена',
      file_uploaded: 'Файл загружен',
      file_downloaded: 'Файл скачан',
      stage_changed: 'Смена этапа',
      status_changed: 'Смена статуса',
      closed: 'Закрытие',
      commission_paid: 'Комиссия выплачена',
      comment_added: 'Комментарий',
    },
  },
  clients: {
    contactsList: {
      primary: 'Основной',
      empty: 'Нет контактов',
      add: 'Добавить контакт',
      valuePlaceholder: 'Значение',
    },
    title: 'Клиенты',
    subtitle: 'Управление клиентской базой',
    listSubtitle: 'Управление клиентской базой · {count} контактов',
    notAssigned: 'Не назначен',
    bulkDelete: { confirm: 'Удалить {count} клиентов?' },
    newClient: 'Новый клиент',
    searchPlaceholder: 'Поиск по имени, телефону, email...',
    create: 'Создать клиента',
    edit: 'Редактировать клиента',
    details: 'Детали клиента',
    list: 'Список клиентов',
    noManager: 'Нет менеджера',
    stats: {
      total: 'Всего клиентов',
      newThisMonth: 'Новые за месяц',
      activeDeals: 'Активные сделки',
      allTime: 'за всё время',
      vsPrevMonth: 'к прошлому месяцу',
      withDeal: 'Со сделкой',
      withDealCaption: 'активные сделки',
      unassigned: 'Без ответственного',
      unassignedCaption: 'требуют распределения',
    },
    filters: {
      title: 'Фильтры',
      stage: 'Этап',
      allStages: 'Все этапы',
      allSources: 'Все источники',
      sourceTree: {
        utmSource: 'Метка: {value}',
      },
      allCities: 'Все города',
      allLanguages: 'Все языки',
      allDealStatuses: 'Все',
      allManagers: 'Все менеджеры',
      withDeal: 'Со сделкой',
      withoutDeal: 'Без сделки',
      dealStatus: 'Статус сделки',
      manager: 'Менеджер',
      allAgents: 'Все агенты',
      agent: 'Агент',
      createdAt: 'Дата создания',
      createdAtPlaceholder: 'Выберите период',
      active: 'Активные фильтры',
      clearAll: 'Очистить все',
      reset: 'Сбросить фильтры',
      tag: 'Тег',
      allTags: 'Все теги',
      archiveReason: 'Причина архивации',
      allArchiveReasons: 'Все причины',
    },
    presets: {
      aria: 'Пресет списка клиентов',
      all: 'Все',
      mine: 'Мои',
      unassigned: 'Без ответственного',
      agents: 'Агентские',
      duplicates: 'Дубли',
    },
    duplicatesBlock: {
      title: 'Дубли от агентов',
      viewAll: 'Все дубли ({n})',
    },
    export: {
      csv: 'CSV (таблица)',
      xlsx: 'Excel (XLSX)',
    },
    import: {
      uploadFile: 'Загрузить файл',
      downloadTemplate: 'Скачать шаблон CSV',
      invalidFormat: 'Поддерживаются только файлы CSV и XLSX',
      failedToast: 'Не удалось импортировать клиентов',
      resultTitle: 'Результат импорта',
      summary: 'Обработано строк: {total}',
      created: 'Создано: {count}',
      merged: 'Дозаполнено: {count}',
      skipped: 'Пропущено: {count}',
      failed: 'С ошибками: {count}',
      errorsTitle: 'Ошибки по строкам',
      line: 'Строка {line}',
    },
    table: {
      client: 'Клиент',
      contact: 'Контакт',
      interest: 'Цель',
      budget: 'Бюджет',
      timeline: 'Срок',
      manager: 'Менеджер',
      createdAt: 'Дата создания',
    },
    actions: {
      changeStatus: 'Изменить статус',
      addClient: 'Добавить клиента',
      createClient: 'Создать клиента',
      retry: 'Попробовать снова',
      addNote: 'Добавить заметку',
      bulkUpdate: 'Массовое обновление',
      assignManager: 'Назначить менеджера',
    },
    bulkUpdate: {
      title: 'Массовое обновление клиентов',
      description: 'Выбрано клиентов: {count}. Укажите поля для обновления.',
      newStage: 'Новый этап',
      newManager: 'Новый менеджер',
      keepCurrent: 'Не менять',
      archiveClients: 'Архивировать клиентов',
      success: 'Обновлено клиентов: {count}',
      error: 'Ошибка при массовом обновлении',
      noChanges: 'Выберите хотя бы одно поле для обновления',
    },
    archive: {
      archive: 'Архивировать',
      unarchive: 'Разархивировать',
      confirmArchive: 'Вы уверены, что хотите архивировать этого клиента?',
      cascadeHint:
        'Активные сделки клиента закроются как «Закрыто и не реализовано», открытые задачи по клиенту и его сделкам будут сняты.',
      revivedOnCreate: 'Клиент с такими контактами был в архиве — карточка восстановлена',
      confirmUnarchive: 'Вы уверены, что хотите разархивировать этого клиента?',
      successArchived: 'Клиент архивирован',
      successUnarchived: 'Клиент разархивирован',
      error: 'Ошибка при архивации клиента',
      archivedAt: 'Архивирован',
      archivedBadge: 'В архиве',
      reason: 'Причина архивации',
      reasonPlaceholder: 'Укажите причину архивации...',
      reasonRequired: 'Укажите причину архивации',
      reasonSelectPlaceholder: 'Выберите причину',
      comment: 'Комментарий',
      commentPlaceholder: 'Детали закрытия (необязательно)...',
    },
    tags: {
      add: 'Навесить тег',
      remove: 'Снять тег',
    },
    detail: {
      noContacts: 'Контакты не указаны',
      preferredContactMethod: 'Предпочтительный способ связи',
      firstContactDate: 'Дата первого контакта',
      responsibleManager: 'Ответственный менеджер',
      call: 'Позвонить',
      write: 'Написать',
      tasks: {
        title: 'Задачи',
        add: 'Добавить задачу',
        edit: 'Редактировать задачу',
        empty: 'Задач пока нет',
        assigneeDefault: 'Ответственный по клиенту (по умолчанию)',
        confirmDelete: 'Удалить задачу?',
      },
      agent: 'Агент',
      agentSource: {
        channel: 'Канал привлечения',
        sourceTypes: {
          Agent: 'Агент',
          Direct: 'Прямой',
          Marketing: 'Маркетинг',
          Referral: 'Реферал',
          Other: 'Другое',
        },
        company: 'Компания',
        openCompany: 'Открыть компанию',
        model: 'Модель',
        special: 'Спец',
        duplicate: 'Дубль',
        duplicateStatuses: {
          not_checked: 'Не проверен',
          duplicate_pending: 'Подозрение на дубль',
          duplicate_confirmed: 'Дубль подтверждён',
          rejected: 'Отклонён',
        },
        comment: 'Комментарий агента',
        // DEV-1918. Канал привлечения / агент (ClientSourceField, §3 дизайна).
        gateHint: 'Меняют ADMIN, HOS, CEO',
        noAgent: 'Агент не указан',
        setAgent: 'Указать агента',
        mismatch: 'канал не согласован',
        mismatchHint:
          'У клиента есть агент, но канал привлечения не «Агент». Смена канала на «Агент» починит рассинхрон.',
        changeAgent: 'Сменить агента',
        openAgent: 'Открыть агента',
        details: 'Подробнее',
        registeredAt: 'Зарегистрирован агентом',
        duplicateReason: 'Причина дубля',
        panelRequest: 'Заявка панели',
        saving: 'Сохраняем…',
        cancelHint: 'вернёт прежний канал, ничего не сохранено',
        picker: {
          placeholder: 'Поиск агента по имени или телефону…',
          empty: 'Агенты не найдены',
          error: 'Не удалось загрузить агентов',
          scopeHint: 'Показаны агенты в вашей зоне',
        },
        confirm: {
          assignTitle: 'Назначить агента?',
          assignDescription: '{agent} станет агентом клиента, канал привлечения — «Агент».',
          assign: 'Назначить',
          assignImpact: 'Агентская атрибуция и вознаграждение перейдут на {n} открытых сделок.',
          changeTitle: 'Сменить агента?',
          changeDescription: 'Агент изменится: {old} → {new}.',
          change: 'Сменить',
          changeImpact: 'Атрибуция {n} открытых сделок перейдёт новому агенту.',
          removeTitle: 'Снять агента?',
          removeDescription:
            '{agent} перестанет быть агентом клиента, канал привлечения станет «{channel}».',
          remove: 'Снять агента',
          removeImpact:
            'Агентская атрибуция и вознаграждение будут сняты с {n} открытых сделок; вознаграждение по ним больше не начисляется.',
          noDeals: 'Открытых сделок нет.',
          sync: 'Открытые сделки клиента будут синхронизированы.',
          dealsError: 'Не удалось посчитать открытые сделки.',
          dealsRetry: 'Повторить подсчёт',
        },
        toast: {
          assigned: 'Агент назначен',
          changed: 'Агент изменён',
          removed: 'Агент снят',
          channelUpdated: 'Канал привлечения обновлён',
          syncPending: 'Сделки обновятся в течение минуты',
        },
      },
      // DEV-1918. Карточка клиента v2: подзаголовки «Команды и атрибуции» и внутренние карточки.
      attribution: { leads: 'ВЕДЁТ', broughtBy: 'ПРИВЁЛ', heardFrom: 'ОТКУДА УЗНАЛ' },
      entryPoints: 'Точки входа',
      loadError: 'Не удалось загрузить клиента',
      inCrmSince: 'в CRM с {date}',
      responsibleShort: 'Отв.: {name}',
      note: 'Заметка',
      focus: { title: 'Фокус', overdue: 'просрочено {n}', more: 'ещё {n}' },
      qualification: {
        title: 'Квалификация',
        subtitle: 'бюджет, цель, сроки, критерии',
        financing: 'Финансирование',
      },
      profile: {
        title: 'Профиль',
        meta: 'Создан {created} · обновлён {updated} · id {id}',
        copyId: 'Скопировать id',
        copied: 'Скопировано',
      },
      team: {
        title: 'Команда и атрибуция',
        notAssigned: 'Не назначен',
        assignSelf: 'Назначить себя',
        impact:
          'Ответственный меняется у клиента — все активные сделки этого клиента ({n}) перейдут новому менеджеру.',
        managersHistory: 'История менеджеров',
      },
      tasksCard: {
        updateError: 'Не удалось обновить задачу',
        add: 'Задача',
        mandatory: 'Обязательная',
        noDue: 'без срока',
        client: 'клиент',
        showAll: 'показать все ({n})',
        collapse: 'свернуть',
        completed: 'выполненные ({n})',
        empty: 'Задач нет',
        openDeal: 'Открыть сделку',
      },
      dealsCard: {
        title: 'Сделки',
        add: 'Сделка',
        current: 'текущая',
        all: 'все ({n})',
        collapse: 'свернуть',
        empty: 'Сделок пока нет',
        mandatory: '{done}/{total} обязательных',
      },
      feed: {
        title: 'Лента',
        placeholder: 'Написать заметку…',
        important: 'Важное',
        add: 'Добавить',
        note: 'заметка',
        interaction: 'взаимодействие',
        more: 'ещё ({n})',
        empty: 'Пока ничего нет',
      },
      contactsCard: {
        empty: 'Контактов нет',
        add: 'Добавить',
        newsletter: 'Рассылка',
        telegramBot: 'Telegram-бот',
        openChat: 'Написать в {provider}',
        email: 'Написать письмо',
        mismatch: '≠ у сделки',
        mismatchHint:
          'Атрибуция сделки зафиксирована при создании. Текущий агент клиента — {agent}. Изменить можно только в карточке клиента.',
        editAtClient: 'Изменить у клиента',
        channelAgent: 'Канал · агент',
        noPhone: 'Телефона нет',
        budget: 'Бюджет',
        loadError: 'Не удалось загрузить контакты',
      },
      you: 'вы',
      assignSelf: 'Назначить себя ответственным',
      assignSelfConfirmTitle: 'Перехватить клиента?',
      assignSelfConfirmDescription:
        'Ответственным сейчас назначен {manager}. Назначить ответственным себя?',
      currentDeal: 'Текущая сделка',
      expectedCommission: 'Ожидаемая комиссия',
      paymentStatus: 'Статус оплаты',
      fundingType: 'Тип финансирования',
      documents: 'Документы',
      stageTasks: 'Задачи этапа',
      addTask: 'Добавить задачу',
      pending: 'невыполненных',
      noTasksForStage: 'Нет задач для этого этапа',
      addFirstTask: 'Добавить первую задачу',
      stageBlockedWarning: 'Невыполненные задачи блокируют переход на следующий этап',
      taskDescription: 'Описание задачи',
      taskDescriptionPlaceholder: 'Введите описание задачи...',
      taskPriority: 'Приоритет',
      taskDueDate: 'Дедлайн',
      changeHistory: 'История изменений',
      noChanges: 'Нет записей в истории',
      loadMore: 'Загрузить ещё',
      files: 'Файлы',
    },
    changeAction: {
      CREATED: 'Клиент создан',
      UPDATED: 'Данные обновлены',
      STAGE_CHANGED: 'Этап изменён',
      STATUS_CHANGED: 'Статус изменён',
      TASK_CREATED: 'Задача создана',
      TASK_UPDATED: 'Задача обновлена',
      TASK_COMPLETED: 'Задача выполнена',
      TASK_DELETED: 'Задача удалена',
      NOTE_ADDED: 'Заметка добавлена',
      NOTE_UPDATED: 'Заметка обновлена',
      NOTE_DELETED: 'Заметка удалена',
      MANAGER_ASSIGNED: 'Менеджер назначен',
      CONTACT_ADDED: 'Контакт добавлен',
      CONTACT_REMOVED: 'Контакт удалён',
      DELETED: 'Клиент удалён',
    },
    stageRequirements: {
      title: 'Требования для этапа',
      remaining: 'не заполнено',
      allComplete: 'Всё заполнено',
      fill: 'Заполнить',
      warning: 'Заполните все поля для перехода на этап "{stage}"',
      readyToAdvance: 'Можно перейти на этап "{stage}"',
    },
    tabs: {
      overview: 'Обзор',
      calls: 'Звонки',
      files: 'Файлы',
      history: 'История',
      chats: 'Чаты',
    },
    emptyState: {
      title: 'Клиентов не найдено',
      noClients: 'Начните с добавления первого клиента',
      withFilters: 'Попробуйте изменить фильтры для поиска клиентов',
    },
    form: {
      personalInfo: 'Личная информация',
      firstName: 'Имя',
      lastName: 'Фамилия',
      dateOfBirth: 'Дата рождения',
      language: 'Язык',
      contacts: 'Контакты',
      addContact: 'Добавить контакт',
      addContactPlaceholder: 'Добавьте хотя бы один контакт',
      noContacts: 'Контакты ещё не добавлены. Нажмите кнопку выше, чтобы добавить контакт.',
      contactType: 'Тип контакта',
      contactValue: 'Значение',
      preferredContact: 'Предпочтительный способ связи',
      clientStatus: 'Статус клиента',
      leadSource: 'Источник лида',
      // DEV-699. Опциональный выбор ответственного при создании клиента.
      managerOptionalAuto: 'Распределить автоматически',
      managerOptionalHint: 'Если менеджер не выбран, клиент распределится автоматически',
      interests: 'Интересы и потребности',
      propertyTypes: 'Типы недвижимости',
      locations: 'Локации',
      budget: 'Бюджет',
      budgetMin: 'Минимум',
      budgetMax: 'Максимум',
      currency: 'Валюта',
      purchaseGoal: 'Цель покупки',
      dealTimeline: 'Срок покупки',
      cityInterest: 'География интереса (город)',
      additionalCriteria: 'Дополнительные критерии',
      additionalInfo: 'Дополнительная информация',
      comment: 'Комментарий',
      subscribeNewsletter: 'Подписать на рассылку',
      preview: 'Предварительный просмотр',
      selectCountry: 'Выберите страну',
      selectStatus: 'Выберите статус',
      selectSource: 'Выберите источник',
      enterCity: 'Введите город',
      enterCityName: 'Введите название города',
      enterLocation: 'Введите локацию и нажмите Enter',
      enterCriteria: 'Введите критерий и нажмите Enter',
      from: 'От',
      to: 'До',
      notSpecified: 'Не указано',
      commentPlaceholder: 'Дополнительная информация о клиенте...',
      checkData: 'Проверьте введенные данные перед созданием',
      selectDate: 'Выберите дату',
      errors: {
        required: 'Это поле обязательно',
        invalidEmail: 'Неверный адрес электронной почты',
        invalidPhone: 'Неверный номер телефона',
      },
    },
    wizard: {
      step1: 'Основное',
      step1Desc: 'Имя, язык, источник',
      step2: 'Контакты',
      step2Desc: 'Телефон, email, каналы',
      step3: 'Бюджет',
      step3Desc: 'Цель, бюджет, финансы',
      step4: 'Завершение',
      step4Desc: 'Ответственный, теги',
      stepOf: 'Шаг {current} из {total}',
      subtitle: 'Заполните карточку клиента по шагам',
      stepsCap: 'ЭТАПЫ',
      responsible: 'Ответственный менеджер',
      create: 'Создать клиента',
    },
    propertyTypes: {
      apartment: 'Квартира',
      villa: 'Вилла',
      townhouse: 'Таунхаус',
      land: 'Земля',
      commercial: 'Коммерческая',
    },
    contactTypes: {
      email: 'Email',
      phone: 'Телефон',
      telegram: 'Telegram',
      whatsapp: 'WhatsApp',
      other: 'Другое',
    },
    enums: {
      contactType: {
        phone: 'Телефон',
        email: 'Email',
        whatsapp: 'WhatsApp',
        telegram: 'Telegram',
        other: 'Другое',
      },
      propertyType: {
        apartments: 'Апартаменты',
        villas: 'Виллы',
        commercial: 'Коммерческая',
      },
      purchaseGoal: {
        investment: 'Перепродажа',
        living: 'Проживание',
        rental: 'Сдача',
      },
      dealTimeline: {
        urgent: 'Срочно',
        threeToSixMonths: '3–6 месяцев',
        moreThanSixMonths: 'Более 6 месяцев',
      },
      paymentStatus: {
        deposit: 'Задаток',
        advance: 'Аванс',
        fullPayment: 'Полная оплата',
      },
      fundingType: {
        mortgage: 'Ипотека',
        installment: 'Рассрочка',
        cash: 'Наличные',
      },
      originEntityType: {
        article: 'Статья',
        residentialComplex: 'Жилой комплекс',
      },
      priority: {
        low: 'Низкий',
        medium: 'Средний',
        high: 'Высокий',
      },
    },
    // DEV-42: clients.stages и clients.kanban удалены — канбан клиента упразднён.
  },
  properties: {
    title: 'Проекты',
    objects: 'объектов',
    addProperty: 'Добавить объект',
    addComplex: 'Добавить ЖК',
    addComplexHint: 'Создание ЖК — в админ-панели',
    listSubtitle: 'Каталог недвижимости · {complexes} в каталоге · {drafts} черновиков',
    found: 'Найдено {count} объектов',
    selected: 'Выбрано: {count} объектов',
    searchPlaceholder: 'Поиск по названию ЖК...',
    statusFilter: {
      all: 'Все',
      published: 'Опубликованные',
      drafts: 'Черновики',
    },
    create: 'Создать объект',
    edit: 'Редактировать объект',
    details: 'Детали объекта',
    list: 'Список объектов',
    views: {
      aria: 'Режим отображения',
      grid: 'Сетка',
      list: 'Список',
      map: 'Карта',
    },
    featureChips: {
      foreigners: 'Для иностранцев',
      pinkBook: 'Pink book',
      video: 'Видео',
      docsChecked: 'Документы',
    },
    // DEV-1003: доступность ЖК агентам (тумблер в «Объектах», admin/hos)
    agentAvailability: {
      badge: 'Доступен агентам',
      toggle: 'Доступен агентам',
      enabled: 'ЖК открыт агентам',
      disabled: 'ЖК скрыт от агентов',
      error: 'Не удалось изменить доступность',
    },
    stats: {
      total: 'Всего комплексов',
      inSale: 'Объектов в продаже',
      featured: 'Рекомендуемые',
      developers: 'Застройщики',
      pending: 'уточняется',
      newThisMonth: 'Новые за месяц',
    },
    sort: {
      name: 'По названию',
      priceAsc: 'Цена: по возрастанию',
      priceDesc: 'Цена: по убыванию',
      area: 'По площади',
      date: 'По дате добавления',
    },
    actions: {
      compare: 'Сравнить',
      clearFilters: 'Очистить фильтры',
      addFirst: 'Добавить первый объект',
      downloadPresentation: 'Скачать PDF',
      generatePresentation: 'Создать PDF',
      generatingPresentation: 'Генерация...',
      regeneratePresentation: 'Перегенерировать',
    },
    emptyState: {
      title: 'Объекты не найдены',
      subtitle: 'Попробуйте изменить параметры поиска или фильтры',
    },
    compare: {
      title: 'Сравнение объектов',
      instruction: 'Выберите от 2 до 4 объектов для сравнения',
    },
    confirm: {
      delete: 'Удалить {count} объектов?',
    },
    tags: {
      recommended: 'Рекомендуем',
    },
    noResults: 'Объекты не найдены',
    roomsCount: '{count} комн.',
    types: {
      apartment: 'Квартира',
      villa: 'Вилла',
      townhouse: 'Таунхаус',
      commercial: 'Коммерческая',
    },
    objectTypes: {
      OBJECT_TYPE_APARTMENT: 'Квартира',
      OBJECT_TYPE_STUDIO: 'Студия',
      OBJECT_TYPE_PENTHOUSE: 'Пентхаус',
      OBJECT_TYPE_VILLA: 'Вилла',
      OBJECT_TYPE_TOWNHOUSE: 'Таунхаус',
      OBJECT_TYPE_DUPLEX: 'Дуплекс',
      OBJECT_TYPE_CONDOTEL: 'Кондотель',
      OBJECT_TYPE_SHOPHOUSE: 'Шопхаус',
      OBJECT_TYPE_OFFICE: 'Офис',
      OBJECT_TYPE_RETAIL: 'Торговое помещение',
      OBJECT_TYPE_LAND: 'Земельный участок',
    },
    filters: {
      searchByName: 'Поиск по названию...',
      projectType: 'Тип проекта',
      type: 'Тип',
      city: 'Город',
      priceFrom: 'Цена от',
      priceTo: 'до',
      moreFilters: 'Больше фильтров',
      hideFilters: 'Скрыть фильтры',
      location: 'Расположение',
      cities: 'Города',
      additional: 'Дополнительно',
      featured: 'Избранное',
      visibility: 'Видимость',
      projectRank: 'Класс проекта',
      amenities: 'Удобства',
      features: 'Особенности',
      apply: 'Применить фильтры',
      drawer: {
        title: 'Фильтры',
        reset: 'Сбросить',
        priceRange: 'Цена, ₫',
        showResults: 'Показать {count} ЖК',
      },
      chips: {
        search: 'Поиск',
        type: 'Тип',
        rooms: 'Комнат',
        rank: 'Класс',
        amenities: 'Удобства',
        features: 'Особенности',
      },
    },
    map: {
      complexesOnMap: '{count} ЖК на карте',
      sortByPrice: 'По цене',
      searchThisArea: 'Искать в этой области',
      loading: 'Загрузка карты...',
    },
    card: {
      addToFavorites: 'Добавить в избранное',
      removeFromFavorites: 'Удалить из избранного',
      addToCompare: 'Добавить к сравнению',
      from: 'от',
      priceOnRequest: 'Цена по запросу',
      objectsCount: '{count} объект | {count} объекта | {count} объектов',
      amenitiesCount: '{count} удобство | {count} удобства | {count} удобств',
      rooms: '{count} комн.',
      area: '{value} м²',
      floor: '{floor}/{total} эт.',
      year: '{year} г.',
      details: 'Подробнее',
      downloadPresentation: 'Скачать презентацию',
      generatePresentation: 'Сгенерировать презентацию',
    },
    status: {
      available: 'Доступно',
      reserved: 'Забронировано',
      sold: 'Продано',
      new: 'Новое',
      hot: 'Горячее',
    },
    detail: {
      errorLoadingData: 'Не удалось загрузить данные объекта',
      objectsInComplex: 'Объекты в комплексе',
      promos: 'Акции',
      aboutObject: 'Об объекте',
      amenities: 'Удобства',
      highlights: 'Преимущества',
      documentsCheck: 'Проверка документов',
      developer: 'Застройщик',
      files: 'Файлы и презентации',
      location: 'Расположение',
      downloadPresentation: 'Скачать презентацию',
      // DEV-2249: на телефоне описания ЖК и застройщика свёрнуты
      showFull: 'Показать полностью',
      collapse: 'Свернуть',
    },
    unitsTable: {
      type: 'Тип',
      rooms: 'Комнаты',
      area: 'Площадь',
      available: 'Доступно',
      price: 'Цена',
    },
    amenityLabels: {
      AMENITY_BAR: 'Бар',
      AMENITY_RESTAURANT: 'Ресторан',
      AMENITY_SPA: 'СПА',
      AMENITY_YOGA: 'Йога',
      AMENITY_CONVENIENCE_STORE: 'Магазин',
      AMENITY_SHOPPING_MALL: 'Торговый центр',
      AMENITY_SCHOOL: 'Школа',
      AMENITY_KINDERGARTEN: 'Детский сад',
      AMENITY_COLLEGE: 'Колледж',
      AMENITY_SWIMMING_POOL: 'Бассейн',
      AMENITY_KIDS_PLAYGROUND: 'Детская площадка',
      AMENITY_GYM: 'Тренажёрный зал',
      AMENITY_COMMUNITY_ROOM: 'Комната отдыха',
      AMENITY_JOGGING_PATH: 'Беговая дорожка',
      AMENITY_BBQ: 'Зона барбекю',
      AMENITY_GREEN_AREA: 'Зелёная зона',
      AMENITY_TENNIS_COURT: 'Теннисный корт',
      AMENITY_KIDS_POOL: 'Детский бассейн',
      AMENITY_PARKING: 'Парковка',
      AMENITY_CAFE: 'Кафе',
    },
    highlightLabels: {
      HIGHLIGHT_REPUTABLE_DEVELOPER: 'Надёжный застройщик',
      HIGHLIGHT_INSTALLMENT_PLAN: 'Рассрочка',
      HIGHLIGHT_FULL_LEGAL_GROUND: 'Полная юридическая чистота',
      HIGHLIGHT_FREE_HIGH_APPRECIATION_POTENTIAL: 'Высокий потенциал роста',
    },
    documentLabels: {
      DEVELOPERS_DOCUMENTS_CHECKING_CONSTRUCTION_PERMIT: 'Разрешение на строительство',
      DEVELOPERS_DOCUMENTS_CHECKING_LAND_USE_RIGHT_CERTIFICATE: 'Свидетельство о праве на землю',
      DEVELOPERS_DOCUMENTS_CHECKING_BANK_LETTER_OF_GUARANTEE: 'Банковская гарантия',
      DEVELOPERS_DOCUMENTS_CHECKING_SALE_PERMIT: 'Разрешение на продажу',
      DEVELOPERS_DOCUMENTS_CHECKING_SALE_PERMIT_FOR_FOREIGNERS: 'Разрешение на продажу иностранцам',
    },
    quickInfo: {
      published: 'Опубликовано',
      hidden: 'Скрыто',
      featured: 'Рекомендуемое',
      minPrice: 'Мин. цена',
      blocks: 'корпусов',
      objectTypes: 'типов объектов',
      handover: 'сдача',
      promos: 'акций',
      objectTypesTitle: 'Типы объектов',
      created: 'Создан',
      updated: 'Обновлен',
      developer: 'Застройщик',
      goToDeveloper: 'Перейти к застройщику',
    },
    tabs: {
      overview: 'Обзор',
      locationTab: 'Расположение',
      developerTab: 'Застройщик',
      documentsTab: 'Документы',
      description: 'Описание',
      features: 'Характеристики',
      amenities: 'Удобства',
      projectHighlights: 'Преимущества проекта',
      location: 'Местоположение',
      noLocation: 'Местоположение не указано',
      projectsCount: '{count} проектов',
      since: 'С {year} года',
      rating: '{value} рейтинг',
      allDeveloperProjects: 'Все проекты застройщика',
      verifiedDocuments: 'Проверенные документы',
      noDocuments: 'Информация о документах недоступна',
    },
  },
  files: {
    source: {
      upload: 'Загрузка',
    },
    dropOrClick: 'Перетащите файлы сюда',
    orClickToSelect: 'или нажмите для выбора',
    uploading: 'Загрузка...',
    loading: 'Загрузка файлов...',
    empty: 'Файлы не загружены',
    emptyDescription: 'Загрузите файлы, перетащив их в область выше',
    fileName: 'Имя файла',
    description: 'Описание',
    descriptionPlaceholder: 'Краткое описание файла (необязательно)',
    uploadFile: 'Загрузка файла',
    upload: 'Загрузить',
    download: 'Скачать',
    rename: 'Переименовать',
    delete: 'Удалить',
    confirmDelete: 'Вы уверены, что хотите удалить этот файл?',
    uploadSuccess: 'Файл загружен',
    uploadError: 'Ошибка загрузки файла',
    deleteSuccess: 'Файл удалён',
    deleteError: 'Ошибка удаления файла',
  },
  documents: {
    title: 'Документы',
    description: 'Шаблоны договоров и генерация PDF-документов по сделкам',
    templates: 'Шаблоны',
    list: 'Документы',
    create: 'Создать',
    filters: { status: 'Статус' },
    status: { draft: 'Черновик', ready: 'Готов' },
    columns: {
      title: 'Название',
      template: 'Шаблон',
      date: 'Дата документа',
      size: 'Размер',
      created: 'Создан',
      status: 'Статус',
    },
    actions: {
      generate: 'Сгенерировать документ',
      download: 'Скачать',
      rename: 'Переименовать',
      delete: 'Удалить',
    },
    empty: {
      title: 'Пока нет документов',
      description: 'Сгенерируйте первый документ по шаблону выше',
      filtered: 'Под выбранные фильтры ничего не нашлось',
    },
    generate: {
      title: 'Новый документ',
      template: 'Шаблон',
      deal: 'Сделка',
      selectDeal: 'Выберите сделку',
      client: 'Клиент',
      selectClient: 'Выберите клиента',
      amount: 'Сумма',
      amountPlaceholder: 'Введите сумму',
      amountInvalid: 'Сумма должна быть положительной',
      noTemplates: 'Шаблоны недоступны — попробуйте обновить страницу',
      date: 'Дата договора',
      submit: 'Сгенерировать',
      success: 'Документ сгенерирован',
      error: 'Не удалось сгенерировать документ',
    },
    rename: {
      title: 'Переименовать документ',
      name: 'Название',
      success: 'Документ переименован',
      error: 'Не удалось переименовать документ',
    },
    confirmDelete: 'Удалить документ? Файл будет удалён без возможности восстановления.',
    deleteSuccess: 'Документ удалён',
    deleteError: 'Не удалось удалить документ',
    downloadError: 'Не удалось скачать файл',
    loadError: 'Не удалось загрузить документы',
    templatesError: 'Не удалось загрузить шаблоны',
    retry: 'Повторить',
  },
  deals: {
    // DEV-210. Срок ближайшей задачи в карточке на канбане.
    nextTask: {
      today: 'сегодня',
      tomorrow: 'завтра',
      inDays: 'через {n} {unit}',
      overdue: 'просрочено {n} {unit}',
      dayOne: 'день',
      dayFew: 'дня',
      dayMany: 'дней',
    },
    title: 'Сделки',
    createDeal: 'Создать сделку',
    searchPlaceholder: 'Поиск по названию или комментарию…',
    funnelSummary: 'Воронка продаж · {count} активных · {amount} в работе',
    views: {
      aria: 'Вид: канбан или список',
      board: 'Канбан',
      list: 'Список',
    },
    table: {
      deal: 'Сделка',
      client: 'Клиент',
      property: 'Объект',
      stage: 'Этап',
      amount: 'Сумма',
      manager: 'Менеджер',
      stageTasks: 'Задачи этапа',
    },
    list: {
      groupByStage: 'Группировать по этапам',
      stageReadyShort: 'Готова',
      mandatoryShort: 'Обяз.',
    },
    loading: 'Загрузка сделок...',
    emptyState: 'Сделки не найдены',
    emptyStateDescription: 'Создайте первую сделку для начала работы',
    noDeals: 'Нет сделок',
    export: {
      csv: 'CSV (таблица)',
      xlsx: 'Excel (XLSX)',
    },
    // Карточка сделки на доске/списке: устойчивость к пустым полям (фрейм 48:2).
    card: {
      noProperty: 'Объект не выбран',
      noPrice: 'Сумма не указана',
      noClient: 'Клиент не указан',
      stageReady: 'Готова к переходу',
      stageBlocked: 'Обязательная не выполнена',
      unassigned: 'Не назначен',
      openInNewTab: 'Открыть в новой вкладке',
    },
    board: {
      ropOnly: 'РОП',
      configurePipeline: 'Настроить воронку',
      wipOver: 'Превышен лимит карточек (WIP)',
      collapseColumn: 'Свернуть колонку',
      expandColumn: 'Развернуть колонку',
      noSum: 'Сумма не определена',
      fullscreen: 'Развернуть на весь экран',
      exitFullscreen: 'Свернуть',
      scrollToRight: 'Прокрутить к правому краю',
      scrollToLeft: 'Прокрутить к левому краю',
    },
    stats: {
      total: 'Всего сделок',
      active: 'Активные',
      won: 'Выиграны',
      lost: 'Проиграны',
      allTime: 'за всё время',
      inWork: '{amount} в работе',
      conversion: 'конверсия {percent}%',
    },
    // DEV-42 / DEV-50: 15 этапов воронки сделки.
    stages: {
      STAGE_TYPE_INVALID: 'Невалидный этап',
      STAGE_TYPE_UNSORTED: 'Не разобрано',
      STAGE_TYPE_NEW_LEAD: 'Новый ЛИД',
      STAGE_TYPE_NO_CONTACT: 'Не вышел на связь',
      STAGE_TYPE_CONTACTED: 'Вышел на связь',
      STAGE_TYPE_QUALIFIED: 'Квалифицирован',
      STAGE_TYPE_OFFER_SENT: 'Предложение отправлено',
      STAGE_TYPE_PRESENTATION_SCHEDULED: 'Презентация назначена',
      STAGE_TYPE_PRESENTATION_DONE: 'Презентация проектов проведена',
      STAGE_TYPE_FOLLOWUP_PRESENTATION_DONE: 'Повторная встреча / презентация проведена',
      STAGE_TYPE_BOOKED: 'Объект выбран',
      STAGE_TYPE_DEPOSIT_PAID: 'Депозит внесен',
      STAGE_TYPE_CONTRACT_SIGNED: 'Договор бронирования подписан / внесен DP',
      STAGE_TYPE_CONTRACT_HANDED_OVER: 'Оригинал договора передан застройщику',
      STAGE_TYPE_COMMISSION_PAID: 'Комиссионные выплачены',
      STAGE_TYPE_LOST: 'Закрыто и не реализовано',
    },
    // DEV-49: справочник причин закрытия сделки. Ключи приходят с бэка из close_reasons.
    closeReason: {
      AGENT: 'Агент',
      RENTAL_NOT_PURCHASE: 'Аренда — нет цели покупки',
      BOUGHT_OTHER: 'Купил другое',
      NO_REQUEST_SUBMITTED: 'Не оставлял заявку',
      NO_CONTACT_5_TOUCHES: 'Не вышел на связь 5 касаний',
      STOPPED_RESPONDING: 'Перестал отвечать',
      LANGUAGE_BARRIER: 'Не говорит на рус/eng',
      NO_BUDGET: 'Нет денег',
      NOT_CONSIDERING_VIETNAM: 'Не готов рассматривать Вьетнам',
      INVALID_CONTACTS: 'Некорректные контакты',
      NOT_TARGET: 'Нецелевой',
      DEFERRED_DEMAND: 'Отложенный спрос',
      PURCHASE_BEYOND_6_MONTHS: 'Покупка более чем через 6 мес',
      CLIENT_ARCHIVED: 'Клиент в архиве',
    },
    statuses: {
      DEAL_STATUS_INVALID: 'Невалидный',
      DEAL_STATUS_ACTIVE: 'Активная',
      DEAL_STATUS_WON: 'Выиграна',
      DEAL_STATUS_LOST: 'Проиграна',
      DEAL_STATUS_CANCELED: 'Отменена',
    },
    filters: {
      allStatuses: 'Все статусы',
      allManagers: 'Все менеджеры',
      allAgents: 'Все агенты',
      allComplexes: 'Все ЖК',
      complexes: 'ЖК',
      complexSearch: 'Название ЖК',
      taskStateHint:
        'Без активных задач — на текущем этапе нет невыполненных задач. Просроченные и на сегодня — по всем задачам сделки; «на сегодня — все» учитывает и выполненные',
      taskState: {
        all: 'Все задачи',
        none: 'Без активных задач',
        overdue: 'Просроченные задачи',
        today_all: 'На сегодня — все',
        today: 'На сегодня — в работе',
      },
      allClientSources: 'Все каналы',
      allLeadSources: 'Все источники лида',
      leadSources: 'Источники лида',
      clientPanel: 'Клиент',
      clientPanelHint:
        'Фильтры по клиенту сделки: город, язык, тег, причина архивации, дата прихода лида',
      leadCreated: 'Дата прихода лида',
      agentSegment: {
        all: 'Все сделки',
        withAgent: 'С агентом',
        withoutAgent: 'Без агента',
      },
      allStages: 'Все стадии',
      dateRange: 'Период создания',
      search: 'Поиск по названию',
    },
    detail: {
      totalPrice: 'Сумма сделки',
      commissionPlannedDate: 'Плановая дата комиссии',
      finance: {
        title: 'Финансы сделки',
        formula: 'база = цена без НДС × ставка ЖК',
        moneyTitle: 'Деньги сделки',
        rewardsTitle: 'Вознаграждения',
        rewardsSubtitle: 'доли агента и команды от базы',
        resultTitle: 'Итог сделки',
        totalWithVat: 'Сумма с НДС',
        totalWithoutVat: 'Сумма без НДС',
        vatHint: 'НДС {rate} %',
        developerRate: 'Застройщик · ставка',
        developerRateField: 'Ставка застройщика, %',
        editRate: 'Изменить ставку застройщика',
        rewardBase: 'База вознаграждений',
        teamGroup: 'Команда',
        managerReward: 'Менеджер',
        hosReward: 'РОП',
        editHosRate: 'Изменить ставку РОПа',
        agentReward: 'Вознаграждение агента',
        editAgentRate: 'Изменить ставку агента',
        hosRateField: 'Ставка РОПа, %',
        agentRateField: 'Ставка агента, %',
        supportReward: 'Сопровождающий',
        netRevenue: 'Очищенная выручка',
        shareOfBase: '{percent} % от базы',
        includeInRevenue: 'Учёт в опер. выручке',
        payments: 'Платежи и инвойсы',
        unitCode: 'Код юнита',
        hotBonus: 'Hot bonus',
        adminFee: 'Admin fee',
        rateRange: 'Ставка — число от 0 до 100',
        saved: 'Финансы сделки сохранены',
        rateConfirm: {
          developerTitle: 'Изменить ставку застройщика?',
          hosTitle: 'Изменить ставку РОПа?',
          agentTitle: 'Изменить ставку агента?',
          description: 'Ставка задаёт базу вознаграждений и очищенную выручку этой сделки.',
          impact: 'Сейчас: база {base} · очищенная выручка {net}',
        },
      },
      registry: {
        title: 'Платежи и инвойсы',
        subtitle: 'инвойсы застройщика и приход комиссии',
        hint: 'Строка реестра сделок: когда застройщик выставит инвойс, когда ждём деньги и что уже пришло. Сохраняется целиком — очищенное поле очищает значение.',
        edit: 'Изменить платежи',
        plannedInvoiceDate: 'Инвойс, план',
        realInvoiceDate: 'Инвойс, факт',
        firstPaymentDate: 'Первый платёж, дата',
        firstPaymentAmount: 'Первый платёж, сумма',
        firstPayment: 'Первый платёж',
        secondPaymentDate: 'Второй платёж, дата',
        secondPaymentAmount: 'Второй платёж, сумма',
        secondPayment: 'Второй платёж',
        commissionReceiptDate: 'Комиссия получена, дата',
        commissionReceived: 'Комиссия получена',
        downPaymentPlanDate: 'Первый взнос, план',
        salesDeptCommission: 'Комиссия отдела продаж',
        reportNote: 'Примечание отчёта',
        amountError: 'Сумма — неотрицательное число',
        percentError: 'Ставка — число от 0 до 100',
      },
      depositPaidAt: 'Дата депозита',
      depositDateUpdated: 'Дата депозита сохранена',
      client: 'Клиент',
      property: 'Жилой комплекс',
      object: 'Объект',
      closeReason: 'Причина закрытия',
      funnel: 'Воронка продаж',
      stageOf: 'этап {current} из {total}',
      nextStage: 'Далее: {stage}',
      changeProperty: 'Изменить',
      selectProperty: 'Выбрать объект',
      changePropertyTitle: 'Объект недвижимости',
      propertyUpdated: 'Объект сделки обновлён',
      propertyUpdateError: 'Не удалось обновить объект сделки',
      comments: 'Комментарии менеджеров',
      summary: 'Сводка',
      changeStage: 'Изменить этап',
      tasks: 'Задачи',
      addTask: 'Добавить задачу',
      editTask: 'Редактировать задачу',
      noDescription: 'Без описания',
      taskDescription: 'Описание',
      taskDescriptionPlaceholder: 'Описание задачи',
      taskDueDate: 'Срок выполнения',
      taskDueTime: 'Время',
      taskAssignee: 'Исполнитель',
      mandatoryTask: 'Обязательная',
      optionalTask: 'Необязательная',
      taskDone: 'Выполнено',
      currentStageTasks: 'Задачи текущего этапа',
      stageTasksNote: 'из шаблона этапа',
      manualTasks: 'Добавлены вручную',
      manualTasksNote: 'не блокируют переход',
      manualTask: 'Вручную',
      noDueDate: 'Без срока',
      manualAddedAt: 'Добавлена {date}',
      upcomingNote: 'не блокируют текущий переход',
      pastAllDone: 'все закрыты',
      pastOpenHint: 'Задачи остались с пройденных этапов — закройте, если они больше не нужны',
      noStageTasks: 'На этапе нет задач',
      funnelBlocked: 'переход заблокирован',
      tabOverview: 'Обзор',
      tabFinance: 'Финансы',
      clientAndObject: 'Клиент и объект',
      tabHistory: 'История',
      tabDocuments: 'Документы',
      tabChats: 'Чаты',
      loadError: 'Не удалось загрузить сделку',
      createdAt: 'создана {date}',
      editPrice: 'Изменить сумму',
      rate: '1 USD ≈ {rate}',
      moreActions: 'Действия со сделкой',
      noHistory: 'Изменений пока нет',
      stageMenu: {
        locked: 'закройте {n} обязательную | закройте {n} обязательные | закройте {n} обязательных',
      },
      deleteConfirm: {
        title: 'Удалить сделку #{id}?',
        description: 'Действие необратимо',
      },
      priority: {
        high: 'Высокий',
        medium: 'Средний',
        low: 'Низкий',
      },
      block: {
        blockedTitle: 'Переход на «{stage}» заблокирован',
        blockedHint: 'Закройте обязательные задачи этапа — ручные задачи переход не блокируют',
        closeMandatory:
          'Закройте {n} обязательную задачу этапа | Закройте {n} обязательные задачи этапа | Закройте {n} обязательных задач этапа',
        okTitle: 'Все обязательные задачи выполнены',
        okHint: 'Можно двигать сделку на следующий этап',
        mandatory: 'обязательных',
      },
      timer: {
        today: 'Сегодня',
        leftOne: 'Остался 1 {unit}',
        left: 'Осталось {n} {unit}',
        overdue: 'Просрочка {n} {unit}',
        inTime: 'Через {n} {unit}',
        createdDue: 'Создана {created} · дедлайн {due}',
        day_one: 'день',
        day_few: 'дня',
        day_many: 'дней',
        hour_one: 'час',
        hour_few: 'часа',
        hour_many: 'часов',
        task_one: 'задача',
        task_few: 'задачи',
        task_many: 'задач',
      },
      taskAssigneeDefault: 'Ответственный по сделке (по умолчанию)',
      taskAssigneeSupport: '{name} (сопровождающий)',
      taskCalendarHint:
        'Задача со сроком автоматически появится в календаре ответственного по сделке',
      reminderCustomHours: 'За N часов',
      reminderHours: 'Часов до срока',
      actionLogs: 'История изменений',
      files: 'Файлы',
      managersHistory: 'История менеджеров',
      managersHistoryCurrent: 'текущий',
      managersHistorySince: 'с',
      confirmDeleteTask: 'Удалить задачу?',
      dealDeleted: 'Сделка удалена',
      titleUpdated: 'Название обновлено',
      stageChanged: 'Стадия изменена',
      priceUpdated: 'Сумма обновлена',
      commissionDateUpdated: 'Плановая дата комиссии обновлена',
      agent: {
        model: 'Модель',
        special: 'Спец',
        rewardPercent: 'Вознаграждение, %',
        involvement: 'Вовлечённость',
        involvementStatus: {
          lead_transfer_only: 'Только передача лида',
          joint_route: 'Совместное ведение',
          inactive: 'Неактивен',
          dispute: 'Спор',
        },
        expectedRewardDate: 'Предполагаемая дата выплаты',
        rewardStatus: 'Статус вознаграждения',
        rewardStatuses: {
          not_applicable: 'Не применимо',
          expected: 'Ожидается',
          approved: 'Подтверждено',
          paid: 'Выплачено',
          disputed: 'Спор',
          cancelled: 'Отменено',
        },
        invalidDate: 'Некорректная дата',
        rewardDateUpdated: 'Дата выплаты обновлена',
        rewardGroup: 'Агентское вознаграждение',
        details: 'Подробнее',
        commissionBase: 'База комиссии',
        expectedReward: 'Ожидаемое вознаграждение',
        specialTerms: 'Спец-условия',
        meetings: 'Встреч с агентом',
        depositPaidAt: 'Депозит внесён',
      },
      updateError: 'Ошибка при обновлении',
      stageChangeError: 'Ошибка при изменении стадии',
      priceUpdateError: 'Ошибка при обновлении суммы',
      addFirstTask: 'Добавить первую задачу',
      taskAdded: 'Задача добавлена',
      taskAddError: 'Ошибка при добавлении задачи',
      taskDeleted: 'Задача удалена',
      taskDeleteError: 'Ошибка при удалении задачи',
      taskMarkedComplete: 'Задача отмечена как выполненная',
      taskReopened: 'Задача переоткрыта',
      taskUpdated: 'Задача обновлена',
      tasksCard: {
        loadError: 'Не удалось загрузить задачи',
        add: 'Задача',
        stage: 'этап «{stage}»',
        pipeline: 'воронка «{pipeline}»',
        upcoming: 'Задачи следующих этапов ({n})',
        past: 'Задачи прошлых этапов ({n})',
        pastOpen: '{n} не закрыто',
        stageGone: 'Этап удалён',
        menu: 'Действия с задачей',
      },
      summaryCard: {
        subtitle: 'объект и ключевые даты',
        dates: 'Создана {created} · обновлена {updated}',
      },
    },
    form: {
      back: '← Назад',
      newDeal: 'Новая сделка',
      editDeal: 'Редактировать сделку',
      clientHint: 'Кому продаём — выберите существующего клиента.',
      objectOptionalHint: 'Объект можно не указывать — например, для этапа «Не разобрано».',
      wizard: {
        subtitle: 'Создание сделки по шагам',
        stepsCap: 'ЭТАПЫ',
        stepOf: 'Шаг {current} из {total}',
        step1: 'Клиент',
        step1desc: 'Кому продаём',
        step2: 'Объект',
        step2desc: 'ЖК и юнит · необязательно',
        step3: 'Сумма',
        step3desc: 'Цена и условия',
        step4: 'Проверка',
        step4desc: 'Подтверждение',
        skip: 'Пропустить',
        back: 'Назад',
        next: 'Далее',
        create: 'Создать сделку',
        reviewHint:
          'Проверьте данные и нажмите «Создать сделку». Сделка появится в воронке на выбранном этапе.',
      },
      loadingData: 'Загрузка данных сделки...',
      mainInfo: 'Основная информация',
      dealTitle: 'Название сделки',
      dealTitlePlaceholder: 'Например: Продажа квартиры в центре',
      relations: 'Связи',
      client: 'Клиент',
      selectClient: 'Выберите клиента',
      clientId: 'ID клиента',
      clientIdPlaceholder: 'ID клиента',
      responsibleManager: 'Ответственный менеджер',
      managerIdPlaceholder: 'ID менеджера',
      // DEV-699. Ответственный по сделке наследуется от ответственного менеджера клиента.
      managerAutoAssigned: 'Назначается по ответственному менеджеру клиента',
      property: 'Недвижимость',
      selectProperty: 'Жилой комплекс',
      selectPropertyPlaceholder: 'Выберите ЖК',
      selectObject: 'Объект',
      selectObjectPlaceholder: 'Выберите объект',
      propertyId: 'Property ID',
      propertyIdPlaceholder: 'ID недвижимости',
      objectId: 'Object ID',
      objectIdPlaceholder: 'ID объекта',
      stageAndFinances: 'Стадия и финансы',
      initialStage: 'Начальная стадия',
      selectStage: 'Выберите стадию',
      finances: 'Финансы',
      currency: 'Валюта',
      selectCurrency: 'Выберите валюту',
      willBeSavedVnd: 'Будет сохранено {amount}',
      totalPrice: 'Сумма сделки',
      priceInCents: 'Сумма в центах',
      dealStatus: 'Статус сделки',
      status: 'Статус',
      noChange: 'Не изменять',
      comment: 'Комментарий',
      additionalInfo: 'Дополнительная информация',
      commentPlaceholder: 'Добавьте комментарий к сделке...',
      titleRequired: 'Название обязательно',
      titleAutoGenerated: 'Если не заполнено, будет сгенерировано из ФИО клиента и названия ЖК',
      clientIdRequired: 'Клиент обязателен',
      saveError: 'Ошибка при сохранении сделки',
    },
    actions: {
      // DEV-49: согласовано с названием этапа «Закрыто и не реализовано» — кнопка ведёт в LOST.
      cancel: 'Провалить',
    },
    // DEV-699. Команда сделки: ответственный + сопровождающие менеджеры.
    team: {
      title: 'Команда сделки',
      responsible: 'Ответственный менеджер',
      supportManagers: 'Сопровождающие менеджеры',
      noSupportManagers: 'Сопровождающие не подключены',
      addSupport: 'Подключить сопровождающего',
      noCandidates: 'Нет доступных сопровождающих менеджеров',
      removeConfirm: 'Отключить сопровождающего {name} от сделки?',
      addSuccess: 'Сопровождающий подключён',
      addError: 'Не удалось подключить сопровождающего',
      addErrorIsResponsible:
        'Пользователь уже является ответственным менеджером этой сделки. Сначала смените ответственного менеджера у клиента.',
      removeSuccess: 'Сопровождающий отключён',
      removeError: 'Не удалось отключить сопровождающего',
      candidatesError: 'Не удалось загрузить список сопровождающих менеджеров',
      // DEV-715. Смена ответственного менеджера (через клиента).
      selectManager: 'Выбрать менеджера',
      responsibleChangeConfirmTitle: 'Сменить ответственного менеджера?',
      responsibleChangeConfirmDescription: 'Ответственный менеджер изменится: {from} → {to}.',
      responsibleChangeConfirmWarning:
        'Ответственный меняется у клиента — все активные сделки этого клиента перейдут новому менеджеру.',
      responsibleChangeSuccess: 'Ответственный менеджер обновлён',
      responsibleChangeError: 'Не удалось сменить ответственного менеджера',
      snapshotHint: 'Снапшот сделки — зафиксирован при создании, правится в карточке клиента',
      responsibleChangePending:
        'Смена ответственного принята и применится в течение минуты. Обновите страницу позже.',
    },
    cancelModal: {
      title: 'Отмена сделки',
      subtitle: 'Сделка «{title}» будет переведена в этап «Закрыто и не реализовано».',
      reasonLabel: 'Причина закрытия',
      reasonPlaceholder: 'Выберите причину...',
      reasonRequired: 'Причина закрытия обязательна',
      commentLabel: 'Комментарий менеджера',
      commentPlaceholder: 'Дополнительная информация (опционально)',
      confirmTitle: 'Подтвердите действие',
      confirmCancel: 'Вы уверены, что хотите отменить эту сделку?',
      confirmButton: 'Да, отменить',
      cancelSuccess: 'Сделка успешно отменена',
      cancelError: 'Ошибка при отмене сделки',
    },
    kanban: {
      dealMoved: 'Сделка перемещена в "{stage}"',
      moveError: 'Ошибка при перемещении сделки',
      cancelForbidden: 'Вы можете отменять только свои сделки',
    },
    currencies: {
      CURRENCY_VND: 'VND (Вьетнамский донг)',
      CURRENCY_USD: 'USD (Доллар США)',
      CURRENCY_RUB: 'RUB (Российский рубль)',
    },
    // DEV-195. Комментарии менеджеров (1:N) в карточке сделки.
    comments: {
      title: 'Комментарии менеджеров',
      empty: 'Комментариев пока нет',
      placeholder: 'Напишите комментарий…',
      add: 'Добавить',
      addSuccess: 'Комментарий добавлен',
      addError: 'Не удалось добавить комментарий',
      updateSuccess: 'Комментарий обновлён',
      updateError: 'Не удалось обновить комментарий',
      deleteSuccess: 'Комментарий удалён',
      deleteError: 'Не удалось удалить комментарий',
      confirmDelete: 'Удалить этот комментарий?',
      edited: 'отредактировано',
      unknownAuthor: 'Неизвестный автор',
      subtitle: 'новые сверху · агентские подсвечены',
      agentBadge: 'Агент',
      agentAuthor: 'Агент',
    },
  },
  notifications: {
    title: 'Уведомления',
    empty: 'Нет уведомлений',
    emptyDesc: 'Здесь будут появляться уведомления о новых сообщениях и событиях',
    markAllRead: 'Прочитать все',
    viewAll: 'Все уведомления',
    loadMore: 'Загрузить ещё',
    allMarkedRead: 'Отмечено прочитанными: {n}',
    time: {
      justNow: 'только что',
      minutesAgo: '{n} мин. назад',
      hoursAgo: '{n} ч. назад',
      daysAgo: '{n} дн. назад',
    },
    webPush: {
      enableTitle: 'Включите push-уведомления',
      enableDesc: 'Получайте уведомления о новых сообщениях прямо в браузере',
      enable: 'Включить',
      enabled: 'Push-уведомления включены',
      denied: 'Разрешение на уведомления отклонено. Проверьте настройки браузера',
    },
    channels: {
      webpush: 'Web Push',
      telegram: 'Telegram',
    },
  },
  settings: {
    title: 'Персональные настройки',
    display: {
      title: 'Отображение',
      language: 'Язык интерфейса',
      languageDesc: 'Выберите язык для отображения интерфейса',
      theme: 'Тема',
      themeDesc: 'Выберите цветовую схему интерфейса',
      itemsPerPage: 'Элементов на странице',
      itemsPerPageDesc: 'Количество элементов для отображения в списках',
      showHints: 'Показывать подсказки',
      showHintsDesc: 'Отображать подсказки и инструкции в интерфейсе',
    },
    languages: {
      ru: 'Русский',
      en: 'English',
      vn: 'Tiếng Việt',
    },
    themes: {
      light: 'Светлая',
      dark: 'Тёмная',
      auto: 'Авто (системная)',
    },
    notifications: {
      title: 'Уведомления',
      groups: {
        deals: 'События сделок',
        tasks: 'Задачи',
        comm: 'Общение',
      },
      types: {
        assigned: 'Назначен ответственным',
        stage: 'Смена этапа сделки',
        wonlost: 'Сделка выиграна/проиграна',
        newtask: 'Новая задача этапа',
        overdue: 'Просрочка задачи',
        digest: 'Дайджест задач на день',
        reminder: 'Напоминание календаря',
        comment: 'Новый комментарий',
        missed: 'Пропущенный звонок',
        unread: 'Непрочитанное сообщение',
      },
      channels: {
        title: 'Каналы доставки',
        push: 'Push (мобильное приложение)',
        webpush: 'Push в браузере',
        email: 'Email',
        telegram: 'Telegram',
        whatsapp: 'WhatsApp',
      },
      telegram: {
        title: 'Telegram бот',
        desc: 'Получайте уведомления о непрочитанных сообщениях через Telegram бота',
        linked: 'Привязан',
        notLinked: 'Не привязан',
        username: 'Telegram аккаунт',
        link: 'Привязать Telegram',
        unlink: 'Отвязать',
        linkInstructions: 'Нажмите на ссылку ниже и отправьте команду /start боту',
        openBot: 'Открыть бота',
        codeExpires: 'Ссылка действительна 10 минут',
        linkCodeError: 'Не удалось получить ссылку на бота. Попробуйте позже.',
        confirmUnlink: 'Отвязать Telegram бота? Уведомления перестанут приходить.',
        unlinkSuccess: 'Telegram бот отвязан',
        linkSuccess: 'Telegram бот привязан! Проверьте бота — он должен подтвердить привязку.',
        checking: 'Проверка статуса...',
        waitingLink: 'Ожидание подключения бота...',
      },
      // DEV-2320: второй бот — только уведомления о новых лидах.
      telegramLeads: {
        title: 'Telegram-бот для лидов',
        desc: 'Получайте уведомления о новых лидах через отдельного Telegram-бота',
        confirmUnlink:
          'Отвязать бота для лидов? Уведомления о новых лидах будут приходить в общий бот.',
        assignedHint: 'Назначенный вам лид приходит в бот для лидов, если бот привязан',
      },
      whatsapp: {
        title: 'WhatsApp уведомления',
        desc: 'Получайте уведомления через WhatsApp',
        linked: 'Подключен',
        notLinked: 'Не подключен',
        phonePlaceholder: 'Номер WhatsApp',
        save: 'Сохранить номер',
        unlink: 'Отвязать',
        confirmUnlink: 'Отвязать WhatsApp? Уведомления перестанут приходить.',
      },
      webPush: {
        title: 'Push-уведомления в браузере',
        desc: 'Получайте уведомления прямо в браузере, даже когда CRM не на активной вкладке',
        notSupported: 'Ваш браузер не поддерживает push-уведомления',
        permissionDenied:
          'Разрешение на уведомления запрещено. Разрешите уведомления в настройках браузера и перезагрузите страницу',
        enable: 'Включить push-уведомления',
        disable: 'Отключить push-уведомления',
        enabled: 'Включены',
        disabled: 'Отключены',
      },
    },
    actions: {
      reset: 'Сбросить настройки',
      save: 'Сохранить изменения',
    },
    confirmReset: 'Вы уверены, что хотите сбросить все настройки к значениям по умолчанию?',
    saved: 'Настройки сохранены!',
  },
  auth: {
    // DEV-1177. Показывается, когда гвард ролей выкинул из CRM внешнюю роль (партнёра).
    roleNotAllowed:
      'У вашей учётной записи нет доступа к CRM. Партнёрская документация — на docs.vinprop.vn.',
    // DEV-1775. Причина отказа при входе — на форме, не тостом.
    loginErrors: {
      deactivated: 'Учётная запись деактивирована. Обратитесь к администратору.',
      notActivated:
        'Учётная запись ещё не активирована. Откройте письмо с приглашением и завершите регистрацию.',
      invalidCredentials: 'Неверный логин или пароль.',
      generic: 'Не удалось войти. Попробуйте ещё раз.',
    },
    // DEV-2119. Вход через Google Workspace: кнопка и причины отказа.
    google: {
      button: 'Войти через Google',
      or: 'или по паролю',
      finishing: 'Завершаем вход…',
      errors: {
        unknown_user: {
          title: 'Учётной записи нет',
          text: 'Аккаунт Google подтверждён, но пользователя с таким адресом в системе нет. Обратитесь к администратору — учётные записи заводятся в CRM.',
        },
        foreign_domain: {
          title: 'Почта вне домена',
          text: 'Войти можно только рабочим адресом. Личный аккаунт Google в систему не пускают.',
        },
        email_not_verified: {
          title: 'Адрес не подтверждён',
          text: 'Google не подтвердил адрес этого аккаунта. Подтвердите его в настройках Google и попробуйте снова.',
        },
        inactive_user: {
          title: 'Учётная запись отключена',
          text: 'Вход по ней закрыт. Обратитесь к администратору.',
        },
        identity_conflict: {
          title: 'Аккаунт уже привязан',
          text: 'Этот аккаунт Google привязан к другой учётной записи. Обратитесь к администратору.',
        },
        canceled: {
          title: 'Вход не завершён',
          text: 'Окно выбора аккаунта Google закрылось раньше времени. Попробуйте ещё раз или войдите по паролю.',
        },
        code_used: {
          title: 'Ссылка уже использована',
          text: 'Одноразовая ссылка возврата действует один раз и одну минуту. Войдите заново.',
        },
        failed: {
          title: 'Не удалось войти',
          text: 'Что-то пошло не так на стороне входа через Google. Попробуйте ещё раз или войдите по паролю.',
        },
      },
    },
    login: 'Вход',
    logout: 'Выход',
    roles: {
      admin: 'Администратор',
      hos: 'Руководитель отдела продаж',
      manager: 'Менеджер',
      // DEV-699. Сопровождающий менеджер сделок.
      support_manager: 'Сопровождающий менеджер',
      agent: 'Агент',
      marketer: 'Маркетолог',
      // DEV-1976. Кампании, ссылки и лендинги с их SEO — и ничего сверх того.
      marketing_manager: 'Менеджер по маркетингу',
      user: 'Пользователь',
      ADMIN: 'Администратор',
      MANAGER: 'Менеджер',
      AGENT: 'Агент',
      USER: 'Пользователь',
    },
    email: 'Email',
    password: 'Пароль',
    forgotPassword: 'Забыли пароль?',
    rememberMe: 'Запомнить меня',
    signIn: 'Войти',
    forgot: {
      title: 'Восстановление пароля',
      hint: 'Укажите e-mail — отправим ссылку для сброса пароля.',
      submit: 'Отправить',
      sent: 'Если такой e-mail зарегистрирован, мы отправили на него ссылку для сброса пароля.',
      backToLogin: 'Вернуться ко входу',
      invalidEmail: 'Введите корректный e-mail',
    },
    reset: {
      title: 'Новый пароль',
      newPassword: 'Новый пароль',
      confirmPassword: 'Повторите пароль',
      submit: 'Сохранить',
      done: 'Пароль изменён. Теперь войдите с новым паролем.',
      tooShort: 'Пароль должен быть не короче 8 символов',
      mismatch: 'Пароли не совпадают',
      invalidToken: 'Ссылка недействительна или устарела. Запросите сброс пароля ещё раз.',
    },
    // DEV-1308. Экран из письма-приглашения.
    accept: {
      title: 'Приглашение в VINPROP',
      hint: 'Придумайте пароль — учётная запись будет создана для',
      firstName: 'Имя',
      lastName: 'Фамилия',
      password: 'Пароль',
      confirmPassword: 'Повторите пароль',
      submit: 'Создать учётную запись',
      required: 'Заполните поле',
      invalidToken:
        'Приглашение недействительно или истекло. Попросите отправить приглашение заново.',
      failed: 'Не удалось принять приглашение. Попробуйте ещё раз или запросите новое.',
    },
  },
  languages: {
    ru: 'Русский',
    en: 'English',
    vn: 'Tiếng Việt',
  },
  countries: {
    by: 'Беларусь',
    cn: 'Китай',
    fr: 'Франция',
    de: 'Германия',
    in: 'Индия',
    id: 'Индонезия',
    jp: 'Япония',
    kz: 'Казахстан',
    my: 'Малайзия',
    ph: 'Филиппины',
    ru: 'Россия',
    sa: 'Саудовская Аравия',
    sg: 'Сингапур',
    kr: 'Южная Корея',
    th: 'Таиланд',
    tr: 'Турция',
    ua: 'Украина',
    ae: 'ОАЭ',
    gb: 'Великобритания',
    us: 'США',
    vn: 'Вьетнам',
  },
  dashboard: {
    title: 'Дашборд',
    welcome: 'Добро пожаловать в VINPROP CRM',
    quickActions: 'Быстрые действия',
    stats: {
      totalClients: 'Всего клиентов',
      activeDeals: 'Активные сделки',
      properties: 'Объекты',
      conversion: 'Конверсия',
      newClients: 'Новые клиенты',
      newDeals: 'Новые сделки',
      newProperties: 'Новые объекты',
      growth: '+{value}% за {period}',
      newThisMonth: '{count} новых за месяц',
      stable: 'Стабильно',
      growing: 'Рост',
      declining: 'Спад',
    },
    periods: {
      day: 'день',
      week: 'неделю',
      month: 'месяц',
      year: 'год',
    },
    actions: {
      manageClients: 'Управление клиентами',
      viewDeals: 'Просмотр сделок',
      browseProperties: 'Обзор объектов',
    },
    hero: {
      greeting: 'С возвращением, {name}',
      summary: 'Сводка по вашей CRM',
    },
    range: {
      today: 'Сегодня',
      week: 'Неделя',
      month: 'Месяц',
      all: 'Всего',
    },
    dealsDynamics: {
      title: 'Динамика сделок',
      subtitle: 'Созданные сделки по месяцам',
      legend: 'Сделки',
      period: '6 месяцев',
      empty: 'Нет данных',
      monthsShort: '{m} мес',
    },
    comingSoon: {
      title: 'Скоро',
      analytics: 'Появится с подключением аналитики',
    },
    tasks: {
      title: 'Задачи на сегодня',
      empty: 'На сегодня задач нет',
      allDay: 'Весь день',
      add: 'Добавить задачу',
      more: 'Ещё {n} задача | Ещё {n} задачи | Ещё {n} задач',
      collapse: 'Свернуть',
    },
    recentClients: {
      title: 'Последние клиенты',
      viewAll: 'Смотреть все',
      colClient: 'Клиент',
      colSource: 'Источник лида',
      colManager: 'Менеджер',
      colCity: 'Город',
      colCreated: 'Добавлен',
      empty: 'Пока нет клиентов',
    },
    leadSources: {
      title: 'Источники лидов',
      unit: 'лидов',
      empty: 'Нет данных по источникам',
    },
  },
  calendar: {
    title: 'Календарь',
    createEvent: 'Создать событие',
    editEvent: 'Редактировать событие',
    deleteEvent: 'Удалить событие',
    today: 'Сегодня',
    more: 'ещё',
    moreTasks: 'задача | задачи | задач',
    allDay: 'Весь день',
    noEvents: 'Нет событий',
    views: {
      month: 'Месяц',
      week: 'Неделя',
      day: 'День',
      agenda: 'Повестка',
    },
    agenda: {
      empty: 'На этот месяц событий нет',
    },
    weekdays: {
      mon: 'Пн',
      tue: 'Вт',
      wed: 'Ср',
      thu: 'Чт',
      fri: 'Пт',
      sat: 'Сб',
      sun: 'Вс',
    },
    form: {
      title: 'Название',
      titlePlaceholder: 'Введите название события',
      description: 'Описание',
      descriptionPlaceholder: 'Введите описание события',
      startDate: 'Дата начала',
      startTime: 'Время начала',
      endDate: 'Дата окончания',
      endTime: 'Время окончания',
      allDay: 'Весь день',
      entityType: 'Тип связи',
      reminder: 'Напоминание',
      manager: 'Менеджер',
    },
    entityTypes: {
      none: 'Без привязки',
      client: 'Клиент',
      deal: 'Сделка',
      clientTask: 'Задача клиента',
      dealTask: 'Задача сделки',
      trackerMeeting: 'Встреча трекера',
    },
    reminders: {
      none: 'Без напоминания',
      '5min': 'За 5 минут',
      '15min': 'За 15 минут',
      '30min': 'За 30 минут',
      '1hour': 'За 1 час',
      '1day': 'За 1 день',
    },
    addToCalendar: 'Добавить в календарь',
    eventCreated: 'Событие создано',
    eventUpdated: 'Событие обновлено',
    eventDeleted: 'Событие удалено',
    legend: {
      title: 'Типы событий',
      client: 'Клиент',
      deal: 'Сделка',
      task: 'Задача',
    },
    filters: {
      categories: 'Категории',
      client: 'Клиенты',
      deal: 'Сделки',
      task: 'Задачи сделок',
      meeting: 'Встречи',
      none: 'Без привязки',
      managers: 'Менеджеры',
      noManagers: 'Менеджеры не найдены',
      taskTypes: 'Типы задач',
      noTaskTypes: 'Типы задач не заведены',
      taskTypesNote: 'Показаны только задачи выбранных типов — события без типа скрыты.',
    },
    prevMonth: 'Предыдущий месяц',
    nextMonth: 'Следующий месяц',
    openInTracker: 'Открыть в трекере',
    openEntity: {
      deal: 'Открыть сделку',
      client: 'Открыть клиента',
    },
  },
  telephony: {
    noCalls: 'Нет звонков',
    callHistory: 'История звонков',
    playRecording: 'Прослушать запись',
    transcriptionAndAi: 'Транскрипция и AI-анализ',
    call: {
      endCall: 'Завершить звонок',
      calling: 'Звонок...',
      callTo: 'Позвонить {phone}',
      call: 'Позвонить',
      endCallLabel: 'Завершить',
      callFailed: 'Не удалось позвонить',
      initiateFailed: 'Не удалось инициировать звонок',
    },
    activeCall: {
      ringing: 'Вызов',
      answered: 'Разговор',
      ended: 'Завершён',
      call: 'Звонок',
      callingEllipsis: 'Вызов...',
      microphone: 'Микрофон',
      endCall: 'Завершить',
      generalCall: 'Общий звонок',
    },
    sip: {
      connected: 'SIP: подключён',
      connecting: 'SIP: подключение...',
      error: 'SIP: ошибка — {error}',
      disconnected: 'SIP: отключён',
    },
    disposition: {
      answered: 'Отвечен',
      busy: 'Занято',
      cancel: 'Отменён',
      noAnswer: 'Нет ответа',
      failed: 'Ошибка',
      ringing: 'Вызов',
    },
    recording: {
      loading: 'Загрузка записи...',
      retry: 'Повторить',
      pause: 'Пауза',
      play: 'Воспроизвести',
      download: 'Скачать',
      unavailable: 'Запись недоступна',
      loadError: 'Не удалось загрузить запись',
      playError: 'Ошибка воспроизведения',
    },
    transcription: {
      unavailable: 'Транскрипция недоступна',
      inProgress: 'Распознавание речи...',
      error: 'Ошибка распознавания',
      aiAnalysis: 'AI-анализ',
      nextSteps: 'Следующие шаги',
      title: 'Транскрипция',
      channel: {
        manager: 'Менеджер',
        client: 'Клиент',
        other: 'Канал {n}',
      },
      qualification: {
        hot: '🔥 Горячий',
        warm: '🌤 Тёплый',
        cold: '❄️ Холодный',
      },
    },
  },
  messenger: {
    noDevice: {
      title: 'WhatsApp не подключён',
      description: 'Подключите WhatsApp аккаунт, чтобы видеть переписку с клиентами',
      connectButton: 'Подключить WhatsApp',
    },
    login: {
      title: 'Подключение WhatsApp',
      scanHint: 'Откройте WhatsApp → Связанные устройства → Привязать устройство',
      expiresIn: 'Действителен {duration} сек.',
      refreshQr: 'Обновить QR',
      clickToGenerate: 'Нажмите "Обновить QR" для генерации кода',
    },
    device: {
      connected: 'WhatsApp подключён',
      disconnect: 'Отключить',
      disconnectTitle: 'Отключение WhatsApp',
      disconnectConfirm:
        'Вы уверены, что хотите отключить WhatsApp? Для повторного подключения потребуется заново отсканировать QR-код.',
    },
    selectChat: 'Выберите чат',
    searchPlaceholder: 'Поиск чатов...',
    send: 'Отправить',
    typeMessage: 'Введите сообщение...',
    attachFile: 'Прикрепить файл',
    call: 'Позвонить через WhatsApp',
    // DEV-998: read-only кросс-менеджерный просмотр Telegram-чатов (ADMIN/CEO/HOS)
    readonly: {
      banner: '👁 Просмотр чата — только чтение',
      bannerNamed: '👁 Просмотр чата {name} — только чтение',
      // DEV-1835: объединённая лента пишет только в support-чат, а его у клиента нет
      mergedNoSupport: '👁 Объединённая лента — только чтение: у клиента нет чата с поддержкой',
      footer: '🔒 Режим просмотра — отправка и звонки недоступны',
    },
    // DEV-2297: support-чат открывается без прочтения, писать — после кнопки
    supportRead: {
      hint: 'Сообщения ещё не прочитаны. Чтобы ответить, нажмите «Прочитать»',
      button: 'Прочитать',
    },
    crossView: {
      // DEV-1833: в списке теперь не только менеджеры, но и «Поддержка».
      selectorLabel: 'Чат',
      selfOption: 'Вы',
      supportOption: 'Поддержка',
      // DEV-2140: чужой чат — это чат менеджера, а не собеседник с таким именем.
      managerOption: 'Личный чат · {name}',
      // DEV-2227: история чужого личного чата появляется, когда его откроет владелец
      historyNotLoaded:
        'История этого чата появится, когда менеджер откроет его в CRM. Новые сообщения видны сразу',
    },
    // DEV-1833: чип «От имени» в композере support-чата
    support: {
      sendAs: 'От имени: {name}',
      managerOptionSoon: 'Отправка от имени менеджера появится позже',
    },
    // DEV-1835: объединённая лента support-чата и личных TG-чатов менеджеров
    mergedFeed: {
      toggle: 'Объединить чаты',
      label: 'Объединённо: {names}',
      toSupport: '→ в Поддержку',
      toManager: '→ {name}',
      fromManager: '{name} · менеджер · личный TG',
      // свой чат админа в объединённой ленте — «Вы», как в подписи состава
      toSelf: '→ вам',
      fromSelf: 'Вы · личный TG',
      // подзаголовок шапки чата (макет MSG-15b)
      subtitle: 'Telegram · объединённая лента: {names}',
      // DEV-2227: источник целиком выше загруженной части ленты
      hiddenAbove: 'Выше есть ещё сообщения: {names}',
    },
    noContact: {
      title: 'Нет WhatsApp-контакта',
      description: 'Добавьте номер WhatsApp в контакты клиента, чтобы видеть переписку',
    },
    noChat: 'Переписка с клиентом ещё не начата',
    noChats: 'Нет чатов',
    noMessages: 'Нет сообщений',
    newMessages: 'Новые сообщения',
    document: 'Документ',
    callEvent: {
      incoming: 'Входящий звонок',
      outgoing: 'Исходящий звонок',
      incomingEnded: 'Входящий звонок',
      outgoingEnded: 'Исходящий звонок',
      incomingRejected: 'Входящий звонок отклонён',
      outgoingRejected: 'Звонок отклонён абонентом',
      missed: 'Пропущенный звонок',
      noAnswer: 'Нет ответа',
      outgoingMissed: 'Без ответа',
      duration: 'Длительность',
      youMissed: 'Вы не ответили',
      declined: 'Отклонён',
    },
    addCaption: 'Добавьте подпись...',
    loadMore: 'Загрузить ещё',
    providers: {
      comingSoon: 'Скоро',
    },
    zalo: {
      connect: {
        title: 'Подключение Zalo OA',
        description: 'Подключите Official Account Zalo для общения с клиентами',
        step1: 'Нажмите кнопку «Подключить»',
        step2: 'Авторизуйтесь в Zalo и разрешите доступ к OA',
        step3: 'После успешной авторизации чаты появятся автоматически',
        button: 'Подключить Zalo OA',
      },
      noOA: {
        title: 'Zalo OA не подключён',
        description: 'Подключите Official Account Zalo, чтобы видеть переписку с клиентами',
        connectButton: 'Подключить Zalo OA',
      },
      noChat: {
        title: 'Нет чата в Zalo',
        description: 'Переписка с этим клиентом через Zalo ещё не начата',
      },
    },
    telegram: {
      comingSoon: {
        title: 'Telegram — скоро',
        description: 'Интеграция с Telegram находится в разработке',
      },
      notConnected: {
        title: 'Telegram не подключён',
        description:
          'Подключите свой аккаунт Telegram, чтобы переписываться с клиентами прямо в CRM',
        connectButton: 'Подключить Telegram',
      },
      // DEV-1712: статус не прочитан — «не подключён» здесь было бы выдумкой.
      statusUnknown: {
        title: 'Состояние Telegram неизвестно',
        description:
          'Не удалось узнать, подключён ли аккаунт. Повторите попытку — аккаунт мог остаться на связи.',
      },
      // DEV-2109: карточка живёт по праву read_all и без личной сессии
      personalOffline: {
        title: 'Личный Telegram не подключён',
        hint: 'Свой чат недоступен, чаты поддержки и коллег открыты',
      },
      clientChatsFailed: 'Не удалось загрузить чаты клиента у других менеджеров',
      supportOffline: 'Аккаунт поддержки сейчас не подключён — сообщения не уйдут',
      // DEV-2109: провал отправки — раньше пузырь просто исчезал
      sendFailed: {
        not_connected: 'Сообщение не отправлено: Telegram-аккаунт не подключён',
        unknown_peer: 'Сообщение не отправлено: диалог ещё не открыт в Telegram',
        flood: 'Telegram просит подождать {seconds} с — сообщение не отправлено',
        generic: 'Не удалось отправить сообщение',
      },
      // DEV-1712: начатый вход, отозванная сессия и упавшая попытка — разные
      // состояния, и ни одно из них не «аккаунт не подключён».
      state: {
        pendingQr: {
          title: 'Вход в Telegram не завершён',
          description: 'QR-код так и не отсканирован. Вернуться к той попытке нельзя.',
        },
        passwordNeeded: {
          title: 'Вход в Telegram ждёт пароль 2FA',
          description: 'Продолжить прошлую попытку нельзя — вход придётся начать заново.',
        },
        revoked: {
          title: 'Сессия Telegram отозвана',
          description: 'Аккаунт остался привязан — войдите в него заново по QR-коду.',
        },
        failed: {
          title: 'Прошлая попытка подключения не удалась',
          description: 'Аккаунт Telegram не подключён. Начните подключение заново.',
        },
        actions: {
          restart: 'Начать заново',
          relogin: 'Войти заново',
        },
      },
      login: {
        title: 'Подключение Telegram',
        generating: 'Генерируем QR-код…',
        qrAlt: 'QR-код для входа в Telegram',
        step1: 'Откройте Telegram на телефоне',
        step2: 'Настройки → Устройства → Подключить устройство',
        step3: 'Наведите камеру на этот QR-код',
        expiresIn: 'Код обновится через {seconds} с',
        expired: 'QR-код истёк',
        refresh: 'Обновить код',
        success: 'Telegram подключён',
        connectedAs: 'Вы вошли как {name}',
        twoFa: {
          description: 'Аккаунт защищён облачным паролем (2FA). Введите его, чтобы завершить вход.',
          label: 'Облачный пароль',
          placeholder: 'Введите пароль',
          submit: 'Продолжить',
          wrongPassword: 'Неверный пароль. Попробуйте ещё раз.',
        },
        error: {
          title: 'Не удалось подключиться',
          generic: 'Что-то пошло не так. Попробуйте ещё раз.',
          // DEV-1712: сессия отдаёт код ошибки, строку подбирает интерфейс.
          loginExpired: 'Попытка входа устарела. Отсканируйте новый код.',
          alreadyConnected: 'Аккаунт уже подключён — сначала отключите текущую сессию.',
          unavailable: 'Telegram сейчас недоступен. Попробуйте позже.',
          logoutFailed: 'Не удалось отключить аккаунт. Попробуйте ещё раз.',
          statusFailed: 'Не удалось узнать состояние аккаунта. Попробуйте ещё раз.',
          retry: 'Повторить',
        },
      },
      session: {
        account: 'Аккаунт Telegram',
        allChats: 'Все чаты',
        disconnect: 'Отключить',
        confirmDisconnect: 'Отключить аккаунт?',
      },
      status: {
        inactive: 'Не подключён',
        pending_qr: 'Ожидание входа',
        password_needed: 'Нужен пароль 2FA',
        active: 'На связи',
        revoked: 'Сессия отозвана',
        error: 'Ошибка',
      },
      typing: 'печатает…',
      noChat: {
        title: 'Чат не найден',
        description:
          'У клиента нет Telegram-юзернейма или телефона, по которому нашёлся бы чат, либо переписки с ним ещё не было.',
      },
      picker: {
        searchPlaceholder: 'Поиск чата по имени или телефону',
        listLabel: 'Список чатов Telegram',
        emptyTitle: 'Чаты не найдены',
        emptyDescription: 'Начните переписку в Telegram — чат появится здесь',
        bound: 'Привязан к этому клиенту',
        bind: 'Привязать',
        bindSuccess: 'Чат привязан к клиенту',
        bindError: 'Не удалось привязать чат',
      },
      call: {
        start: 'Позвонить',
        panelTitle: 'Звонки',
        empty: 'Звонков пока нет',
        loadError: 'Не удалось загрузить звонки',
        unknownPeer: 'Абонент',
        accept: 'Принять',
        decline: 'Отклонить',
        cancel: 'Отменить',
        mute: 'Без звука',
        hangup: 'Завершить',
        today: 'Сегодня',
        expand: 'Развернуть',
        collapse: 'Свернуть',
        close: 'Закрыть',
        outgoingCall: 'Исходящий звонок',
        incomingCall: 'Входящий звонок',
        endedTitle: 'Звонок завершён',
        recording: 'Запись',
        transcript: 'Транскрипция',
        aiSummary: 'AI-резюме',
        nextSteps: 'Следующие шаги',
        noRecording: 'Запись не велась',
        transcriptPending: 'Расшифровка готовится…',
        transcriptNone: 'Расшифровка недоступна',
        state: {
          connecting: 'Соединение…',
          ringing: 'Вызов…',
          active: 'Разговор',
          incoming: 'Входящий звонок',
        },
        recStatus: {
          ready: 'запись готова',
          processing: 'обработка записи…',
          failed: 'расшифровка недоступна',
        },
        qual: {
          hot: 'Hot',
          warm: 'Warm',
          cold: 'Cold',
        },
        speaker: {
          manager: 'Менеджер',
          client: 'Клиент',
        },
        error: {
          generic: 'Не удалось выполнить звонок',
          mic_denied: 'Нет доступа к микрофону',
          busy: 'Уже идёт другой звонок',
          ws_disconnected: 'Нет связи с сервером',
          webrtc_error: 'Ошибка соединения',
          connection_failed: 'Соединение прервано',
        },
      },
    },
  },
  agencyBot: {
    title: 'Бот агентской поддержки',
    desc: 'Уведомления об обращениях агентов с кнопками «Взять / Закрыть / Передать».',
    connect: 'Подключить бота',
    instructions: 'Откройте бота и нажмите «Запустить» — чат привяжется автоматически.',
    openBot: 'Открыть бота',
    codeExpires: 'Ссылка действует 15 минут.',
  },
  profile: {
    title: 'Кабинет',
    changeAvatar: 'Изменить аватар',
    telegram: {
      title: 'Telegram-аккаунт',
      account: 'Аккаунт Telegram',
      notConnected: 'Telegram-аккаунт не подключён. Подключите его, чтобы писать клиентам из CRM.',
      connect: 'Подключить Telegram',
      change: 'Сменить',
      disconnect: 'Отключить',
      confirmDisconnect: 'Отключить аккаунт?',
    },
    personalInfo: 'Личная информация',
    name: 'Имя',
    email: 'Email',
    role: 'Роль',
    timezone: 'Часовой пояс',
    timezonePlaceholder: 'Выберите часовой пояс',
    save: 'Сохранить',
    saved: 'Сохранено',
    noChanges: 'Нет изменений',
    languages: 'Языки',
    password: {
      title: 'Смена пароля',
      current: 'Текущий пароль',
      new: 'Новый пароль',
      confirm: 'Повторите новый пароль',
      submit: 'Сменить пароль',
      done: 'Пароль изменён',
      tooShort: 'Пароль должен быть не короче 8 символов',
      mismatch: 'Пароли не совпадают',
      wrongOld: 'Неверный текущий пароль',
      failed: 'Не удалось сменить пароль. Попробуйте ещё раз.',
    },
  },
  agentsRegistry: {
    title: 'Агенты',
    comingSoon: 'Раздел «Компании» скоро (DEV-478)',
    soon: 'скоро',
    notAssigned: 'Не назначен',
    privateAgent: 'Частный агент',
    searchPlaceholder: 'Поиск по ФИО, телефону, компании…',
    tabs: { agents: 'Агенты', companies: 'Компании' },
    filters: {
      status: 'Статус',
      responsible: 'Ответственный',
      registeredRange: 'Дата регистрации',
    },
    columns: {
      fullName: 'ФИО агента',
      company: 'Компания',
      country: 'Страна',
      status: 'Статус',
      offer: 'Оферта',
      model: 'Модель',
      clients: 'Клиент.',
      deals: 'Сдел.',
      responsible: 'Ответственный',
    },
    status: {
      candidate: 'Кандидат',
      pending_offer: 'Ждёт оферту',
      new_partner: 'Новый партнёр',
      onboarding: 'Онбординг',
      active: 'Активен',
      dormant: 'Спящий',
      blocked: 'Заблокирован',
      archived: 'В архиве',
    },
    offer: {
      not_sent: 'Не отпр.',
      sent: 'Отправлена',
      accepted: 'Принята',
      needs_reacceptance: 'Переподтв.',
      rejected: 'Отклонена',
      suspended: 'Приостановлена',
    },
    markers: {
      companyUnconfirmed: 'Компания не подтверждена',
      offerNotAccepted: 'Оферта не принята',
      specialTerms: 'Спецусловия',
      checkShort: 'проверка',
    },
    empty: {
      title: 'Агенты не найдены',
      withFilters: 'Под выбранные фильтры ничего не нашлось',
      noAgents: 'Пока нет ни одного агента',
    },
    actions: {
      addAgent: 'Добавить агента',
      reset: 'Сбросить фильтры',
      addTask: 'Поставить задачу',
    },
    agentRole: 'Агент',
    tabs2: {
      overview: 'Обзор',
      clients: 'Клиенты',
      deals: 'Сделки',
      reward: 'Вознаграждение',
      offer: 'Оферта',
      tasks: 'Задачи',
      history: 'История',
    },
    kpi: {
      clientsTransferred: 'Передано клиентов',
      transferredNote: 'всего у агента',
      activeDeals: 'Активные сделки',
      deposits: 'Депозитов',
      rewardForecast: 'Прогноз вознаграждения',
    },
    assignment: {
      auto_matched: 'Сопоставлена авто',
      manual_confirmed: 'Подтверждена',
      requires_verification: 'Требует проверки',
      private_agent_confirmed: 'Частный агент',
      unknown: '—',
    },
    detail: {
      contacts: 'Контакты',
      commercial: 'Коммерческие условия',
      phone: 'Телефон',
      responsible: 'Ответственный',
      source: 'Источник',
      agentClients: 'Клиенты агента',
      allClients: 'Все клиенты',
      companyAndSource: 'Компания и источник',
      confirmation: 'Подтверждение',
      coordinator: 'Координатор',
      client: 'Клиент',
      date: 'Дата',
      deal: 'Сделка',
      openDeal: 'Открыть',
      noClients: 'У агента пока нет клиентов',
      clientsStageHint: 'Этап и следующий шаг подтянутся из сделок (read-model, DEV-482).',
      offerBlock: 'Оферта',
      status: 'Статус',
      version: 'Версия',
      acceptedAt: 'Дата принятия',
      rewardPercent: 'Процент',
      validTo: 'Действует до',
      rewardForecast: 'Прогноз вознаграждения',
      degraded482: '— (read-model, DEV-482)',
      dealsSoonTitle: 'Сделки клиентов',
      dealsSoon: 'Появятся после наполнения read-model (DEV-482) и связки сделок с агентом.',
      tasksSoonTitle: 'Задачи агента',
      tasksSoon: 'Появятся в Волне 2 (agent_tasks).',
      notFound: 'Агент не найден',
    },
    form: {
      email: 'Email',
      fullName: 'ФИО',
      phone: 'Телефон',
      company: 'Компания',
      companyPlaceholder: 'Выберите компанию',
      responsible: 'Ответственный',
      language: 'Язык',
      country: 'Страна',
      city: 'Город',
      comment: 'Комментарий',
      created: 'Агент создан',
      createError: 'Не удалось создать агента',
    },
  },
  partnerCompanies: {
    title: 'Компании-партнёры',
    searchPlaceholder: 'Поиск по названию компании…',
    system: 'Системная',
    actions: { addCompany: 'Добавить компанию' },
    filters: { status: 'Статус', type: 'Тип' },
    columns: {
      name: 'Название',
      type: 'Тип',
      status: 'Статус',
      agreement: 'Договор',
      agents: 'Агентов',
      clients: 'Клиентов',
      model: 'Модель',
      responsible: 'Ответственный',
    },
    status: {
      new: 'Новая',
      active: 'Активна',
      dormant: 'Спящая',
      blocked: 'Заблокирована',
      archived: 'В архиве',
      requires_verification: 'Требует проверки',
    },
    type: {
      agency: 'Агентство',
      brokerage: 'Брокер',
      developer_partner: 'Партнёр застройщика',
      private_agent: 'Частный агент',
      other: 'Другое',
    },
    agreement: {
      not_started: 'Не начат',
      sent: 'Отправлен',
      signed: 'Подписан',
      expired: 'Истёк',
      suspended: 'Приостановлен',
      terminated: 'Расторгнут',
    },
    empty: {
      title: 'Компании не найдены',
      withFilters: 'Под выбранные фильтры ничего не нашлось',
      noCompanies: 'Пока нет ни одной компании',
    },
    tabs: {
      overview: 'Обзор',
      contacts: 'Контакты и координатор',
      agents: 'Агенты',
      clientsDeals: 'Клиенты и сделки',
      documents: 'Документы',
      reports: 'Отчёты',
    },
    kpi: {
      agents: 'Агентов',
      agentsNote: 'привязано к компании',
      clients: 'Клиентов',
      activeDeals: 'Активные сделки',
      rewardForecast: 'Прогноз вознаграждения',
    },
    detail: {
      agreement: 'Партнёрский договор',
      responsible: 'Ответственный',
      document: 'Документ',
      docsSoon: 'Документы появятся позже.',
      website: 'Сайт',
      contract: 'Договор',
      defaultModel: 'Модель по умолч.',
      companyAgents: 'Агенты компании',
      agent: 'Агент',
      noAgents: 'У компании пока нет агентов',
      coordinator: 'Координатор партнёрства',
      role: 'Должность',
      contractTerms: 'Договор и условия',
      signedAt: 'Дата подписания',
      signedShort: 'подписан',
      clientsDealsTitle: 'Клиенты и сделки компании',
      documentsTitle: 'Документы компании',
      reportsTitle: 'Отчёты по компании',
      reportsSoon: 'Появятся в analytics (Волна 2).',
      notFound: 'Компания не найдена',
    },
    form: {
      name: 'Название компании',
      typePlaceholder: 'Выберите тип',
      modelPlaceholder: 'Не задана',
      created: 'Компания создана',
      createError: 'Не удалось создать компанию',
    },
    autocomplete: {
      minChars: 'Введите минимум 3 символа',
      noResults: 'Ничего не найдено',
    },
  },
  agents: {
    portalTitle: 'Кабинет агента',
    logout: 'Выйти',
    cabinet: {
      submitClient: 'Передать клиента',
      more: 'Ещё',
      menu: {
        sections: 'Разделы',
        settings: 'Настройки',
        language: 'Язык',
        profileSub: 'Оферта, модель, куратор',
        educationSub: '5 стратегий VINPROP',
        supportSub: 'Встреча, вопрос, FAQ',
      },
      onboarding: {
        skip: 'Пропустить',
        back: 'Назад',
        start: 'Начать',
        next: 'Далее',
        welcome: {
          title: 'Добро пожаловать в VINPROP',
          text: 'Это ваш кабинет агента. За 5 шагов настроим работу: оферта, профиль, компания — и можно передавать клиентов.',
        },
        offer: {
          title: 'Оферта принята',
          text: 'Вы приняли оферту при регистрации — её текст и версия всегда доступны в разделе «Профиль и компания».',
        },
        profile: {
          title: 'Ваш профиль',
          text: 'Контакты, язык и таймзона — в разделе «Профиль и компания». Коммерческие условия настраивает ваш менеджер VINPROP.',
        },
        company: {
          title: 'Компания-партнёр',
          text: 'Ваша компания и куратор закреплены в профиле. По любым вопросам пишите в «Поддержку».',
        },
        done: {
          title: 'Всё готово!',
          text: 'Кабинет настроен. Передавайте клиентов — мы доведём сделку и начислим вознаграждение.',
          submit: 'Передать клиента',
          toCabinet: 'В кабинет',
        },
      },
      searchPlaceholder: 'Поиск клиентов, сделок…',
      soon: 'скоро',
      nav: {
        dashboard: 'Дашборд',
        clients: 'Мои клиенты',
        deals: 'Мои сделки',
        projects: 'Проекты',
        reward: 'Вознаграждение',
        education: 'Обучение',
        profile: 'Профиль и компания',
        support: 'Поддержка',
      },
      projects: {
        title: 'Проекты',
        searchPlaceholder: 'Поиск по названию проекта…',
        availableCount: 'Доступно вам проектов: {count}',
        statusOnSale: 'В продаже',
        statusHandedOver: 'Сдан',
        details: 'Подробнее',
        submitClient: '+ Передать клиента',
        emptyTitle: 'Пока нет доступных проектов',
        emptyText: 'Проекты появятся здесь, когда менеджер VINPROP откроет вам доступ.',
        contactSupport: 'Написать в поддержку',
        errorTitle: 'Не удалось загрузить проекты',
        errorText: 'Попробуйте обновить страницу позже.',
        about: 'О проекте',
        units: 'Юниты и цены',
        unitType: 'Тип',
        unitArea: 'Площадь',
        unitPrice: 'Цена от',
        materials: 'Материалы для клиента',
        presentation: 'Презентация',
        download: 'Скачать',
        ctaTitle: 'Работайте с этим проектом',
        ctaText:
          'Передайте клиента по этому проекту — менеджер VINPROP проведёт сделку и зафиксирует ваше вознаграждение.',
      },
      dashboard: {
        greeting: 'Здравствуйте, {who}',
        onboardingTitle: 'Завершите настройку профиля',
        onboardingText: 'Подтвердите компанию, изучите стратегии и передайте первого клиента.',
        onboardingContinue: 'Продолжить',
        onboardingHide: 'Скрыть',
        kpi_clients: 'Передано клиентов',
        kpi_deals: 'Активные сделки',
        kpi_deposits: 'Депозиты',
        kpi_reward: 'Прогноз вознаграждения',
        kpiClientsHint: 'переданных всего',
        kpiDealsHint: '{n} в депозите',
        kpiDepositsHint: 'внесён депозит',
        kpiRewardHint: 'по активным сделкам',
        nextSteps: 'Ближайшие шаги',
        noTasks: 'Нет ближайших задач',
        recentDeals: 'Последние сделки',
        allDeals: 'Все сделки',
        noDeals: 'Пока нет сделок',
      },
      clients: {
        searchPlaceholder: 'Поиск по имени',
        colClient: 'Клиент',
        colSource: 'Источник',
        colStatus: 'Статус',
        colNextStep: 'Следующий шаг',
        nextStepInline: 'Следующий шаг: {step}',
        colDeal: 'Сделка',
        dealOpen: 'Открыть',
        loading: 'Загрузка…',
        empty: 'Пока нет переданных клиентов',
      },
      clientStatus: {
        new: 'Новый',
        in_progress: 'В работе',
        deposit_paid: 'Депозит',
        won: 'Сделка закрыта',
        closed: 'Закрыт',
      },
      nextStep: {
        manager_contact: 'Менеджер свяжется',
        manager_in_progress: 'В работе у менеджера',
        deal_closing: 'Закрытие сделки',
        completed: 'Завершено',
      },
      deals: {
        searchPlaceholder: 'Поиск по сделке, клиенту',
        selectHint: 'Выберите сделку для продолжения',
        colDeal: 'Сделка',
        colClient: 'Клиент',
        colStage: 'Этап',
        colDeposit: 'Депозит',
        colForecast: 'Прогноз',
        colPayoutDate: 'Дата выплаты',
        colPayoutStatus: 'Статус выплаты',
        depositYes: 'Внесён',
        depositNo: 'Нет',
        empty: 'Пока нет сделок',
      },
      reward: {
        forecast: 'Прогноз вознаграждения',
        forecastHint: 'по активным сделкам',
        approved: 'Утверждено',
        approvedHint: 'готово к выплате',
        paid: 'Оплачено',
        paidHint: 'за всё время',
        empty: 'Пока нет вознаграждений',
      },
      rewardStatus: {
        expected: 'Ожидается',
        approved: 'Утверждено',
        paid: 'Оплачено',
        unavailable: 'Не применимо',
      },
      education: {
        strategiesTitle: 'Инвестиционные стратегии VINPROP',
        strategiesSubtitle:
          'Изучите все 5 стратегий перед активной работой с клиентами — это поможет точнее квалифицировать запрос.',
        watchYoutube: 'смотреть на YouTube',
        webinarsTitle: 'Вебинары',
        webinarsEmpty: 'Пока нет запланированных вебинаров',
        register: 'Записаться',
        registered: 'Вы записаны',
        watchRecording: 'Запись',
        materialsTitle: 'Материалы для агентов',
        materials: {
          presentations: 'Презентации проектов',
          pricelists: 'Прайс-листы',
          recordings: 'Записи вебинаров',
          instructions: 'Инструкции и регламенты',
        },
      },
      profile: {
        agentTitle: 'Профиль агента',
        agentRole: 'Агент',
        phone: 'Телефон',
        email: 'Email',
        whatsapp: 'WhatsApp',
        telegram: 'Telegram',
        location: 'Страна / город',
        timezone: 'Часовой пояс',
        language: 'Язык',
        lang: { ru: 'Русский', en: 'Английский', vn: 'Вьетнамский' },
        statusValue: {
          active: 'Active',
          pending: 'На рассмотрении',
          blocked: 'Заблокирован',
          inactive: 'Неактивен',
        },
        offerTitle: 'Оферта и модель',
        offerStatus: 'Статус оферты',
        offerValue: {
          accepted: 'Принята',
          pending: 'Не принята',
          sent: 'Отправлена',
          declined: 'Отклонена',
        },
        offerVersion: 'Версия оферты',
        offerAcceptedAt: 'Дата принятия',
        modelTitle: 'Модель вознаграждения',
        modelValue: {
          '30_percent': '30% — передача клиента',
          '50_percent': '50% — совместное ведение',
          special_terms: 'Спецусловия',
        },
        modelDesc: 'Описание модели',
        companyTitle: 'Компания-партнёр',
        company: 'Компания',
        coordinator: 'Координатор',
        coordinatorRole: 'Роль',
        partnerManager: 'Менеджер по партнёрам',
        documents: 'Документы',
        offerDoc: 'Оферта агента',
        partnerContract: 'Партнёрский договор',
        open: 'Открыть',
        changeTitle: 'Нужно изменить модель или данные?',
        changeText:
          'Контакты и коммерческие условия меняет ваш менеджер VINPROP. Напишите в поддержку.',
      },
      companyVerify: {
        title: 'Компания на проверке',
        statusRequires: 'Требует подтверждения',
        typed: 'Введено: «{name}»',
        recommended: '{pct}% рекомендуем',
        cta: 'Выбрать компанию',
        privateAgent: 'Я частный агент',
        privateAgentHint: 'Работаю самостоятельно, без агентства.',
        loading: 'Подбираем варианты вашей компании…',
        pending: 'Идёт подбор вашей компании — вернитесь чуть позже.',
        noResult: 'Не нашли вашу компанию. Напишите куратору — заведём вручную.',
        confirmSuccess: 'Компания выбрана — ждёт подтверждения менеджером.',
        confirmError: 'Не удалось выбрать компанию. Попробуйте ещё раз.',
      },
      support: {
        myTickets: 'Мои обращения',
        noTickets: 'У вас пока нет обращений',
        backToList: 'К списку',
        threadEmpty: 'Сообщений пока нет',
        you: 'Вы',
        staff: 'VINPROP',
        replyPlaceholder: 'Ваш ответ…',
        send: 'Отправить',
        otherQuestion: 'Другой вопрос',
        questionLabel: 'Ваш вопрос',
        questionPlaceholder: 'Опишите вопрос одним сообщением…',
        sendQuestion: 'Отправить вопрос',
        questionSent: 'Вопрос отправлен — ответим в рабочее время.',
        faq: 'Частые вопросы',
        faqItems: {
          fixation: {
            q: 'Как происходит закрепление клиента?',
            a: 'Клиент закрепляется за вами на 90 дней с момента передачи; сделки по нему учитываются как ваши.',
          },
          payout: {
            q: 'Когда выплачивается вознаграждение?',
            a: 'После выхода сделки на оплату комиссии VINPROP; ориентировочную дату видно в разделе «Вознаграждение».',
          },
          duplicate: {
            q: 'Что делать, если клиент уже в базе?',
            a: 'Система пометит дубль на проверке; решение принимает менеджер — следите за статусом в «Мои клиенты».',
          },
          models: {
            q: 'Чем отличаются модели 30% и 50%?',
            a: '30% — вы передаёте клиента, сделку ведёт VINPROP; 50% — совместное ведение. Модель задаёт менеджер.',
          },
        },
      },
    },
    login: {
      title: 'Вход в агентскую панель',
      subtitle: 'Передавайте клиентов, отслеживайте сделки и вознаграждение.',
      email: 'Email',
      password: 'Пароль',
      submit: 'Войти',
      forgot: 'Забыли пароль?',
      noAccount: 'Нет аккаунта?',
      register: 'Зарегистрироваться',
      notAgent: 'Эта учётная запись не является агентской.',
      error: 'Неверный email или пароль.',
    },
    offer: {
      back: 'Назад',
      version: 'Редакция оферты № {version}',
    },
    register: {
      title: 'Регистрация партнёра',
      subtitle: 'Заполните данные, чтобы начать работу. После регистрации подтвердите email.',
      backHome: 'На главную',
      sectionPartner: 'Данные партнёра',
      sectionContacts: 'Контакты',
      sectionSecurity: 'Безопасность',
      stepLanguage: 'Язык',
      stepOffer: 'Оферта',
      stepProfile: 'Анкета',
      language: 'Язык',
      email: 'Email',
      password: 'Пароль',
      passwordHint: 'Минимум 8 символов',
      confirmPassword: 'Повторите пароль',
      passwordMismatch: 'Пароли не совпадают',
      agency: 'Агентство',
      fullName: 'ФИО',
      phone: 'Телефон',
      country: 'Страна',
      city: 'Город',
      whatsapp: 'WhatsApp',
      telegram: 'Telegram',
      comment: 'Комментарий',
      offerTitle: 'Публичная оферта',
      offerText: 'Принимаю условия',
      offerLink: 'публичной оферты',
      personalData: 'Согласен на обработку персональных данных',
      dataAccuracy: 'Подтверждаю достоверность указанных данных',
      next: 'Далее',
      back: 'Назад',
      submit: 'Зарегистрироваться',
      hasAccount: 'Уже есть аккаунт?',
      signIn: 'Войти',
      successTitle: 'Почти готово!',
      successText:
        'Мы отправили письмо для подтверждения на {email}. Перейдите по ссылке из письма, затем войдите.',
    },
    forgot: {
      title: 'Восстановление пароля',
      email: 'Email',
      submit: 'Отправить ссылку',
      sent: 'Если такой email зарегистрирован, мы отправили на него ссылку для сброса пароля.',
      backToLogin: 'Вернуться ко входу',
    },
    reset: {
      title: 'Новый пароль',
      password: 'Новый пароль',
      confirm: 'Повторите пароль',
      submit: 'Сохранить пароль',
      mismatch: 'Пароли не совпадают.',
      success: 'Пароль изменён. Теперь можно войти.',
      toLogin: 'Войти',
    },
    confirm: {
      verifying: 'Подтверждаем email…',
      success: 'Email подтверждён! Теперь можно войти.',
      error: 'Не удалось подтвердить email. Ссылка недействительна или истекла.',
      toLogin: 'Войти',
    },
    home: {
      greeting: 'Здравствуйте, {name}!',
      agency: 'Агентство: {agency}',
      submitClient: 'Зарегистрировать клиента',
      description: 'Передайте контакт клиента — мы зафиксируем его за вами на 90 дней.',
      menuSubtitle:
        'Выберите нужное действие. Все обращения фиксируются и направляются ответственному сотруднику VINPROP.',
      menuAriaLabel: 'Действия агента',
      menu: {
        partnership: {
          title: 'Партнёрство',
          subtitle: 'Условия сотрудничества и регистрация агентства',
        },
        registerClient: {
          title: 'Зарегистрировать клиента',
          subtitle: 'Передать контакт и закрепить клиента за собой',
        },
        commission: {
          title: 'Вознаграждение',
          subtitle: 'Узнать статус и срок выплаты по сделке',
        },
        meeting: {
          title: 'Назначить встречу',
          subtitle: 'Запросить встречу с клиентом по сделке',
        },
        strategies: {
          title: 'Изучение стратегий',
          subtitle: 'Видео и материалы для продаж',
        },
        other: {
          title: 'Другой вопрос',
          subtitle: 'Задать вопрос ответственному сотруднику',
        },
      },
      connectBot: {
        title: 'Подключить Telegram-бот',
        desc: 'Те же действия — прямо в Telegram: сделки, вознаграждение, встречи и вопросы.',
        connect: 'Подключить бота',
        instructions:
          'Откройте бота и нажмите «Запустить» — кабинет привяжется к вашему Telegram автоматически.',
        openBot: 'Открыть в Telegram',
        copyLink: 'Скопировать ссылку',
        copied: 'Скопировано',
        codeExpires: 'Ссылка действует 15 минут.',
        error: 'Не удалось получить ссылку. Попробуйте ещё раз.',
      },
    },
    partnership: {
      back: 'На главную',
      title: 'Сотрудничество с VINPROP',
      registeredTitle: 'Вы уже зарегистрированы как партнёр VINPROP',
      registeredText: 'Перейдите в агентский кабинет или выберите нужный раздел в меню.',
      toCabinet: 'Перейти в агентский кабинет',
      registerClient: 'Зарегистрировать клиента',
      myDeals: 'Мои сделки',
    },
    strategies: {
      back: 'На главную',
      title: 'Изучение стратегий',
      subtitle:
        'Подборка видео по ключевым инвестиционным стратегиям VINPROP. Рекомендуем изучить все 5 перед активной работой с клиентами — это поможет точнее квалифицировать запрос.',
      watch: 'Смотреть на YouTube',
      videos: {
        v1: '1. Стратегия структурного роста',
        v2: '2. Стратегия капитализации городских кластеров',
        v3: '3. Стратегия отельного дефицита',
        v4: '4. Стратегия концентрации капитала',
        v5: '5. Лайфстайл стратегия',
      },
      note: 'После просмотра вы сможете точнее определять, какая стратегия подходит конкретному клиенту, и передавать более качественные заявки.',
      ask: 'Задать вопрос по стратегиям',
      questionLabel: 'Ваш вопрос',
      questionPlaceholder: 'Опишите вопрос по стратегиям одним сообщением…',
      submit: 'Отправить вопрос',
    },
    other: {
      back: 'На главную',
      title: 'Другой вопрос',
      subtitle:
        'Опишите ваш вопрос одним сообщением. Мы передадим его ответственному сотруднику VINPROP.',
      label: 'Ваш вопрос',
      placeholder:
        'Например: как оформляется закрепление клиента, если он уже обращался в VINPROP ранее?',
      note: 'Обращение попадёт в маршрут Agency Support. Резервный ответственный — Head of Sales.',
      submit: 'Отправить вопрос',
    },
    inquiry: {
      success: {
        title: 'Обращение принято',
        subtitle: 'Передано ответственному сотруднику VINPROP. Мы ответим вам в рабочее время.',
        ticketLabel: 'Номер обращения',
        typeLabel: 'Тип',
        statusLabel: 'Статус',
        statusNew: 'Новое',
        toHome: 'На главную',
      },
      types: {
        other: 'Другой вопрос',
        strategy_question: 'Изучение стратегий',
      },
    },
    deals: {
      title: 'Мои сделки',
      subtitle:
        'Сделки, где вы указаны как агент. Имя клиента маскируется в целях конфиденциальности.',
      back: 'На главную',
      clientLabel: 'Клиент: {name}',
      empty: {
        title: 'Пока нет привязанных сделок',
        description: 'Зарегистрируйте клиента — сделка появится здесь после создания в CRM.',
        action: 'Зарегистрировать клиента',
      },
      error: {
        title: 'Не удалось загрузить сделки',
        retry: 'Повторить',
      },
    },
    commission: {
      title: 'Вопрос по вознаграждению',
      subtitle: 'Выберите сделку, чтобы узнать ожидаемую дату выплаты вознаграждения.',
      back: 'На главную',
      selectedDeal: 'Выбранная сделка',
      changeDeal: 'Выбрать другую сделку',
      dateLabel: 'Ожидаемая дата получения вознаграждения',
      pendingTitle: 'Дата выплаты уточняется',
      pendingFallback:
        'Ожидаемая дата выплаты по этой сделке пока уточняется. Мы передали запрос специалисту по сопровождению сделок.',
      note: 'Обращения по вознаграждению направляются ответственному сотруднику VINPROP; статус можно уточнить здесь.',
      error: {
        title: 'Не удалось загрузить данные',
        retry: 'Повторить',
      },
    },
    meeting: {
      title: 'Назначить встречу по сделке',
      subtitle: 'Выберите сделку и удобные параметры — менеджер согласует встречу.',
      back: 'На главную',
      selectedDeal: 'Выбранная сделка',
      changeDeal: 'Выбрать другую сделку',
      withWhom: {
        label: 'С кем встреча',
        client: 'Клиент',
        agent: 'Агент',
        both: 'Клиент + агент',
      },
      date: 'Дата',
      time: 'Время',
      format: {
        label: 'Формат встречи',
        zoom: 'Zoom',
        googleMeet: 'Google Meet',
        whatsapp: 'WhatsApp',
        offline: 'Офлайн',
      },
      comment: 'Комментарий',
      commentPlaceholder: 'Цель встречи, вопросы клиента…',
      submit: 'Отправить заявку',
      success: {
        title: 'Заявка передана',
        subtitle: 'Менеджер свяжется с вами для подтверждения времени и формата встречи.',
        detailsTitle: 'Детали заявки',
        dealLabel: 'Сделка',
        formatLabel: 'Формат',
        timeLabel: 'Желаемое время',
        toHome: 'На главную',
      },
      error: {
        title: 'Не удалось загрузить данные',
        retry: 'Повторить',
      },
    },
    submit: {
      back: 'На главную',
      cancel: 'Отмена',
      title: 'Уведомление о клиенте',
      subtitle: 'Передайте клиента — он будет закреплён за вами в CRM.',
      clientName: 'Имя клиента',
      clientPhone: 'Телефон',
      clientEmail: 'Email',
      clientLanguage: 'Язык клиента',
      clientCountry: 'Страна',
      propertyInterest: 'Интерес / пожелания',
      propertyInterestPlaceholder: 'Бюджет, район, тип недвижимости, цель покупки…',
      clientConsent: 'Клиент дал согласие на обработку персональных данных',
      dataAccuracy: 'Подтверждаю достоверность указанных данных',
      submit: 'Передать клиента',
      resultCreatedTitle: 'Клиент зарегистрирован',
      resultDuplicateTitle: 'Уже в базе',
      resultPendingTitle: 'Заявка принята',
      fixationTitle: 'Клиент закреплён за вами',
      fixationText:
        'Срок фиксации — до {date}. В течение этого срока сделка с этим клиентом относится к вам.',
      toHome: 'На главную',
      close: 'Закрыть',
      another: 'Передать ещё клиента',
    },
    validation: {
      required: 'Обязательное поле',
      email: 'Некорректный email',
      phone: 'Некорректный номер телефона',
      selectCountryFirst: 'Сначала выберите страну',
      minPassword: 'Минимум 8 символов',
      consents: 'Необходимо принять все согласия',
    },
    tags: {
      AGENT_LEAD: 'Агентский',
      DUPLICATE: 'Дубль',
    },
  },
  routing: {
    title: 'Маршрутизация обращений',
    subtitle: 'Правила, кому направляются обращения агентов и через сколько эскалировать.',
    addRule: 'Добавить правило',
    createTitle: 'Новое правило',
    editTitle: 'Редактирование правила',
    deleteTitle: 'Удалить правило',
    deleteText: 'Удалить правило маршрутизации «{type}»? Действие необратимо.',
    saved: 'Правило сохранено',
    saveError: 'Не удалось сохранить правило',
    deleted: 'Правило удалено',
    empty: 'Правил маршрутизации пока нет',
    primaryKind: {
      role: 'Роль',
      user: 'Пользователь',
      dealManager: 'Менеджер сделки',
    },
    fields: {
      requestType: 'Тип обращения',
      requestTypePlaceholder: 'commission_question, meeting_request, other…',
      primaryKind: 'Кому направлять',
      primaryValue: 'Значение',
      primaryValueHint: 'user_id для пользователя, ключ роли для роли; пусто для менеджера сделки',
      fallbackRoleKey: 'Резервная роль',
      slaMinutes: 'SLA, минут',
      condition: 'Условие',
      conditionPlaceholder: 'JSON-условие (необязательно)',
      enabled: 'Активно',
    },
  },
  reports: {
    // DEV-285. Раздел «Отчёты» на analytics-API.
    title: 'Отчёты',
    subtitle: 'Аналитика продаж: выручка, воронка, источники лидов, менеджеры',
    empty: 'Нет данных за период',
    // DEV-380. Под-табы раздела «Отчёты».
    tabs: {
      overview: 'Обзор',
      managers: 'Менеджеры',
      sales: 'Отдел продаж',
      salesFinance: 'Сделки и выручка',
    },
    sales: {
      subtitle:
        'Статусная структура заявок, динамика потока, эффективность источников и качество агентских лидов',
      periodPlaceholder: 'Период отчёта',
      exportXlsx: 'Выгрузить XLSX',
      empty: 'Нет заявок за период',
      emptyDescription: 'Выберите другой период или дождитесь новых лидов',
      kpiTotal: 'Всего лидов',
      kpiEffective: 'Осталось в работе',
      kpiNoDialog: 'Закрыто без диалога',
      structureTitle: 'Статусная структура заявок',
      monthsTitle: 'Динамика по месяцам',
      sourcesTitle: 'Эффективность источников',
      agentsTitle: 'Качество агентских лидов',
      colClass: 'Категория',
      colLeads: 'Лидов',
      colShare: 'Доля',
      colMonth: 'Месяц',
      colDelta: 'Изменение',
      deltaBaseline: 'Сравнение: {period} — {leads} заявок',
      colPerDay: 'Лидов в день',
      colSource: 'Источник',
      colActiveWarming: 'Активные + прогрев',
      colDeals: 'Сделки',
      colClosed: 'Закрыто',
      colEffective: 'Результативность',
      colAgentLeads: 'Агентских лидов',
      colInWork: 'В работе',
      colQuality: 'Качество',
      colQualityDelta: 'Δ качества',
      colFirstContact: 'Первый контакт',
      colAgency: 'АН',
      colAgent: 'Агент',
      colContacts: 'Контакты',
      colTerms: 'Ставка',
      colMeetings: 'Встречи',
      colFollowUps: 'Follow-up',
      colGeo: 'Страна / город',
      colRecruitStatus: 'Статус вербовки',
      colCurator: 'Куратор',
      colNote: 'Примечание',
      journalTitle: 'Журнал работы с агентами АН',
      journalManager: 'Куратор',
      journalEmpty: 'Агентов нет',
      journalEmptyDescription: 'Под выбранного куратора не нашлось ни одного агента',
      insightsTitle: 'Аналитическое заключение',
      insightsRefresh: 'Обновить выводы',
      insightsEmpty: 'Выводов по этому периоду пока нет',
      insightsGeneratedAt: 'Сформировано {date}',
      insightsPeriod: 'Период: {period}',
      exportSettings: {
        title: 'Настройки отчётов',
        folder: 'Папка Google Drive',
        folderPlaceholder: 'https://drive.google.com/drive/folders/...',
        folderHint: 'Папка должна лежать на общем диске, доступ у сервис-аккаунта VINPROP',
        folderError: 'Папка недоступна — проверьте ссылку и доступ',
        schedule: 'Периодичность',
        scheduleDay: 'Каждый день',
        scheduleWeek: 'Каждую неделю',
        scheduleMonth: 'Каждый месяц',
        window: 'Окно данных',
        windowAll: 'За всё время',
        windowMonths: 'Последние {n} мес.',
        enabled: 'Автоматическая выгрузка включена',
        runNow: 'Выгрузить сейчас',
        openFile: 'Открыть файл ↗',
        nextRun: 'Следующая выгрузка: {date}',
        saved: 'Настройки сохранены',
        started: 'Выгрузка запущена',
        finished: 'Отчёт выгружен в Google Drive',
        alreadyRunning: 'Выгрузка уже идёт',
        status: {
          running: 'Выгружается',
          success: 'Выгружен',
          error: 'Ошибка',
        },
      },
      noSource: 'Без источника',
      dataQualityTitle: 'Качество данных',
      dqClosedButContacted: 'Закрыто как «нет диалога», хотя диалог был',
      dqActiveWithoutDialog: 'Активные без единого диалога',
      hints: {
        kpiTotal:
          'Все лиды, созданные в выбранном периоде — по дате создания карточки клиента. Знаменатель для всех долей отчёта.',
        kpiEffective:
          'Лиды, оставшиеся в работе: сделки + активные + прогрев. В скобках — доля от всех лидов периода. Показывает, сколько потока не осыпалось.',
        kpiNoDialog:
          'Лиды, закрытые с причиной «Не вышел на связь». В скобках — доля от всех лидов периода. Рост показателя — повод проверить скорость реакции менеджеров.',
        structureTitle:
          'Распределение всех лидов периода по категориям. Категория вычисляется автоматически, вручную её не выставляют.',
        monthsTitle:
          'Поток лидов по месяцам создания: объём, прирост к прошлому месяцу и разбивка по категориям.',
        sourcesTitle:
          'Сравнение источников: сколько лидов дал каждый и какая их доля осталась в работе.',
        agentsTitle:
          'Лиды, приведённые агентами: сколько из них остаётся в работе. Считаются только лиды с заполненным агентом.',
        dataQualityTitle:
          'Проверка непротиворечивости данных: расхождения между причиной закрытия лида и фактом контакта. Ненулевые значения означают, что цифры выше стоит перепроверить.',
        class:
          'Категория вычисляется по первому подошедшему правилу: есть сделка → «Сделки»; тег «Тест» или «Дубль» → «Тест/дубль»; лид в архиве → «Закрыто»; тег «Прогрев» → «Прогрев»; остальные → «Активные».',
        leads: 'Количество лидов этой категории, созданных в периоде.',
        share: 'Доля категории от всех лидов периода.',
        month: 'Месяц создания лида — по дате создания карточки клиента.',
        delta:
          'Прирост количества лидов к предыдущему месяцу, в процентах. У месяца, обрезанного границей периода, сравнение идёт с тем же отрезком дней предыдущего месяца — иначе половина месяца всегда выглядела бы провалом. С чем именно сравнили, видно при наведении на значение.',
        perDay:
          'Среднесуточный поток: лиды месяца, делённые на дни месяца, попавшие в период отчёта. У незакрытого месяца темп не занижается.',
        source:
          'Источник лида из справочника. Лиды без источника собраны в отдельную строку «Без источника».',
        sourceLeads: 'Сколько лидов пришло из этого источника за период.',
        sourceShare: 'Доля источника в общем потоке лидов периода.',
        activeWarming:
          'Лиды источника в категориях «Активные» и «Прогрев» — те, с кем работа продолжается.',
        deals: 'Лиды источника, по которым уже есть сделка.',
        closed: 'Лиды источника, ушедшие в архив.',
        effectiveShare:
          'Сделки + активные + прогрев, делённые на все лиды этого источника. Сравнивает источники по качеству лида, а не по объёму: источник с малым, но живым потоком может быть выгоднее массового.',
        agentLeads: 'Лиды за месяц, у которых заполнен приведший агент.',
        inWork:
          'Из них остались в работе: сделки + активные + прогрев. Закрытые и тест/дубль не считаются.',
        quality:
          '«В работе», делённое на «Агентских лидов» за месяц. Показывает, приводят ли агенты целевых клиентов: 100% — не отвалился ни один лид, низкое значение — поток пустой.',
        qualityDelta:
          'Изменение качества к предыдущему месяцу, в процентных пунктах — разница двух процентов, а не процент от процента.',
        journalTitle:
          'Журнал вербовки агентов АН: кого завели, на каких условиях и сколько встреч с ними провели. Период фильтра относится только к счётчикам встреч и follow-up — сам список агентов периодом не режется, иначе из журнала пропали бы агенты, заведённые раньше, с которыми работа шла именно сейчас.',
        firstContact:
          'Дата появления агента в системе: саморегистрация в кабинете или заведение карточки менеджером.',
        agency:
          'Агентство: подтверждённая компания-партнёр, иначе название, указанное самим агентом при регистрации.',
        contacts:
          'Все каналы связи агента: телефон, WhatsApp, Telegram, Instagram. Для части агентов АН Instagram — единственный рабочий канал.',
        terms:
          'Коммерческая модель: 30% — передача клиента, 50% — совместное ведение, «Спец» — индивидуальные условия (для них показан согласованный процент).',
        meetings:
          'Встречи с агентом за период: проведено / заведено. «Проведено» = задача-встреча закрыта.',
        followUps:
          'Повторные контакты за период: выполнено / заведено. Задачи типа «Follow-up» из карточки агента.',
        recruitStatus:
          'Этап вербовки: кандидат → ждёт оферту → новый партнёр → онбординг → активен. Спящие, заблокированные и архивные агенты остаются в журнале, чтобы история вербовки не терялась.',
        insightsTitle:
          'Выводы по цифрам этого отчёта, сформулированные моделью: динамика потока, сильные и слабые источники, узкие места конверсии. Модель видит только агрегаты — карточки клиентов ей не передаются. Заключение сохраняется на конкретные цифры: пока они не изменились, при следующем открытии придут те же выводы, а «Обновить выводы» просит сформулировать заново.',
        dqClosedButContacted:
          'Лиды, закрытые с причиной «Не вышел на связь», хотя переписка или отвеченный звонок в CRM есть. Причина проставлена неверно, и «Закрыто без диалога» в сводке завышено.',
        dqActiveWithoutDialog:
          'Лиды в работе, по которым нет ни переписки, ни отвеченного звонка: первый контакт ещё не состоялся.',
        classes: {
          deal: 'По клиенту есть хотя бы одна сделка. Правило проверяется первым, поэтому теги и архив на категорию уже не влияют.',
          active: 'Лид в работе: не в архиве, без сделки и без тегов «Прогрев», «Тест», «Дубль».',
          warming: 'Тег «Прогрев»: клиент интересен, но решение отложено.',
          closed: 'Лид в архиве. Причина закрытия выбирается из справочника при архивации.',
          test_duplicate:
            'Тег «Тест» или «Дубль» — служебные карточки. Из результативности исключаются, чтобы не портить статистику.',
        },
      },
      classes: {
        deal: 'Сделки',
        active: 'Активные',
        warming: 'Прогрев',
        closed: 'Закрыто',
        test_duplicate: 'Тест/дубль',
      },
    },
    // DEV-1882 (эпик DEV-1870). Экранная версия листа «Отчет и сделки» файла РОПа.
    finance: {
      subtitle:
        'План и факт месяца внутри периода цели, недельная динамика и сделки, из которых сложилась выручка',
      month: 'Месяц',
      includeLeadership: 'Включая сделки руководства',
      exportXlsx: 'Выгрузить XLSX',
      noTarget: 'На этот месяц нет цели',
      noTargetHint: 'Планы и проценты будут нулевыми, пока цель не задана в настройках отчёта.',
      rewardsTitle: 'Вознаграждения месяца',
      weeksTitle: 'Недельный план-факт',
      dealsTitle: 'Свод сделок',
      emptyDeals: 'За период нет сделок с депозитом',
      emptyDealsHint: 'Сделка попадает в отчёт по дате депозита; проверьте, проставлена ли она.',
      week: 'Неделя',
      dates: 'Даты',
      colPlan: 'План комиссионных',
      colRevenue: 'Операционная выручка',
      colNetRevenue: 'Очищенная выручка',
      colCumulative: 'Накопительно',
      colDeposits: 'Депозиты, шт.',
      colClient: 'Клиент',
      colUnit: 'Проект / юнит',
      colDeposit: 'Депозит',
      colBase: 'База',
      colAgent: 'Агент',
      colManager: 'Менеджер',
      colHos: 'РОП',
      colNet: 'Очищенная',
      colOwner: 'Кто вёл',
      colCounted: 'Учёт',
      countedYes: 'Да',
      countedNo: 'Нет',
      noClient: 'Без клиента',
      kpi: {
        monthRevenue: 'Операционная выручка месяца',
        monthPlan: 'План месяца',
        monthNetRevenue: 'Очищенная выручка месяца',
        monthDeals: 'Сделок в месяце',
        periodRevenue: 'Выручка за период',
        periodNetRevenue: 'Очищенная за период',
        avgCommission: 'Средняя комиссия',
        excludedDeals: 'Исключено сделок',
        agentReward: 'Вознаграждение агентов',
        managerReward: 'Вознаграждение менеджеров',
        hosReward: 'Вознаграждение РОПа',
        ratesFilled: 'Заполнено ставок менеджера',
        agentsAttracted: 'Агентов привлечено',
        agentClients: 'Клиентов от агентов',
      },
      settings: {
        title: 'Настройки отчёта',
        hint: 'Валюта показа, курс и цели по периодам. Цель делится на недели пропорционально дням, поэтому задаётся отрезком дат.',
        display: 'Показ',
        currency: 'Валюта отчёта',
        rate: 'Курс USD/VND',
        rateHint:
          'Цель задаётся в долларах, а выручка приходит в донгах — без курса их не сравнить.',
        rateError: 'Курс — положительное число',
        targets: 'Цели по периодам',
        noTargets: 'Целей пока нет',
        period: 'Период',
        periodFrom: 'Начало периода',
        periodTo: 'Конец периода',
        goal: 'Цель',
        goalUsd: 'Цель, USD',
        goalError: 'Цель — положительное число',
        addTarget: 'Добавить цель',
        saved: 'Настройки отчёта сохранены',
      },
    },
    kpi: {
      revenue: 'Выручка',
      averageCheck: 'Средний чек',
      conversion: 'Конверсия',
      dealsWon: 'Сделок выиграно',
    },
    revenue: {
      title: 'Динамика выручки',
    },
    funnel: {
      title: 'Воронка продаж',
      dealsReached: 'Сделок на этапе',
      fromTop: 'От первого этапа',
    },
    leadSources: {
      title: 'Источники лидов',
    },
    leaderboard: {
      title: 'Лидерборд менеджеров',
      manager: 'Менеджер',
      won: 'Выиграно',
      lost: 'Проиграно',
      winRate: 'Win-rate',
      revenue: 'Выручка',
      averageCheck: 'Средний чек',
      clients: 'Клиентов',
    },
    // DEV-197. Аналитика менеджеров (только РОП/админ).
    managerAnalytics: {
      title: 'Аналитика менеджеров',
      subtitle: 'Участие в сделках по этапам, задачи и исходы Won/Lost — для KPI и вознаграждения',
      allManagers: 'Все менеджеры',
      period: 'Период',
      dealsWon: 'Сделок выиграно',
      dealsLost: 'Сделок проиграно',
      tasksCompleted: 'Задач выполнено',
      tasksOverdue: 'Задач просрочено',
      tasks: 'Задачи менеджеров',
      winLoss: 'Исходы сделок (Won/Lost)',
      stageParticipation: 'Участие в сделках по этапам',
      empty: 'Нет данных',
      emptyDescription: 'По выбранным фильтрам данных нет',
    },
  },
}
